import React from "react";
import PropTypes from "prop-types";

import withStyles from "@material-ui/core/styles/withStyles";
import Swal from "sweetalert2";

import CustomInput from "components/CustomInput/CustomInput.jsx";
import Icon from "@material-ui/core/Icon";
import {
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Modal,
  ModalHeader,
  FormText,
  ModalBody,
  ModalFooter
} from "reactstrap";

import Warning from "@material-ui/icons/Warning";

import PersonAddDisabled from "@material-ui/icons/PersonAddDisabled";
import Assessment from "@material-ui/icons/Assessment";
import AccountBox from "@material-ui/icons/AccountBox";
import Home from "@material-ui/icons/Home";
import EventNote from "@material-ui/icons/EventNote";
import Person from "@material-ui/icons/Person";
import ChatBubble from "@material-ui/icons/ChatBubble";
import TransferWithinAStation from "@material-ui/icons/TransferWithinAStation";
import MonetizationOn from "@material-ui/icons/MonetizationOn";
import ShoppingCart from "@material-ui/icons/ShoppingCart";
import Cached from "@material-ui/icons/Cached";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import MaterialTable from "material-table";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import conf from "../../conf.json";
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import "../TableList/tablelist.css";
import axios from "axios";

import ReactExport from "react-data-export";
import readXlsxFile from "read-excel-file";

//import '../../assets/jss/read-excel-file.min.js'
//import $ from 'https://code.jquery.com/jquery-3.3.1.js'

import { PulseLoader } from "react-spinners";
import "../../assets/css/load.css";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

class TableList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      cs:true,
      selectSaleExport: "all",
      modal: false,
      modalUpload: false,
      txtnoti:"ค่าเริ่มต้น",
      daten:(new Date()).toISOString().substr(0,10),
      timen:"12:00",
      tmp_contact: {
        sales_id: "",
        acfirstname:"",
        aclastname:"",
        call_center_name:"",
        account_no:""
      },
      modalExport: false,
      modalDeleteCompany: false,
      modalNotify: false,
      modalChangeStatus: false,
      modalReceiveEmail: false,
      modalSearch: false,
      modalAddnote: false,
      dataAll: [],
      tmp_account_no: "",
      dataAllInSale: [],
      data0: [],
      data1: [],
      data1_1: [],
      data1_2: [],
      data1_3: [],
      data1_4: [],
      data2: [],
      data3: [],
      data4: [],
      data5: [],
      simpleSelect: "",
      selectall: "all",
      selectsale: "all",
      sales: [],
      Loading: false,
      notes: [],
      status: "",
      modal: false,
      openEditSec1: false,
      openEditSec2: false,
      openEditSec3: false,
      openEditSec4: false,
      note: "",
      sales_data: [],
      exportAll: true,
      export0: true,
      export1: true,
      export11: true,
      export12: true,
      export13: true,
      export14: true,
      export2: true,
      export3: true,
      export4: true,
      export5: true,
      dataFind: [],
      dataFindTmp: [],
      selectcallcenter: "",
      user: [],
      callcenter: [],
      dataExcelTemp: [
        {
          columns: [
            { title: "สถานะ", width: { wch: 20 } },
            { title: "ID บริษัท", width: { wch: 20 } },
            { title: "ชื่อภาษาไทย", width: { wch: 40 } },
            { title: "ชื่อภาษาอังกฤษ", width: { wch: 40 } },
            { title: "เลขประจำตัวผู้เสียภาษี", width: { wch: 30 } },
            { title: "กลุ่มของบริษัท (ชื่อภาษาไทย)", width: { wpx: 90 } },
            { title: "กลุ่มของบริษัท (ชื่อภาษาอังกฤษ)", width: { wpx: 90 } },
            { title: "ID บริษัทสำนักงานใหญ่", width: { wpx: 90 } },
            { title: "บ้านเลขที่", width: { wpx: 90 } },
            { title: "หมู่", width: { wpx: 90 } },
            { title: "ซอย", width: { wpx: 90 } },
            { title: "หมูบ้าน", width: { wpx: 90 } },
            { title: "ถนน", width: { wpx: 90 } },
            { title: "แขวง/ตำบล", width: { wpx: 90 } },
            { title: "เขต/อำเภอ", width: { wpx: 90 } },
            { title: "จังหวัด", width: { wpx: 90 } },
            { title: "รหัสไปรษณีย์", width: { wpx: 90 } },
            { title: "เบอร์โทรศัพท์ 1", width: { wpx: 90 } },
            { title: "เบอร์โทรศัพท์ 2", width: { wpx: 90 } },
            { title: "ชื่อผู้ติดต่อ 1", width: { wpx: 90 } },
            { title: "เบอร์โทรติดต่อ 1", width: { wpx: 90 } },
            { title: "Email", width: { wpx: 90 } },
            { title: "ตำแหน่ง", width: { wpx: 90 } },
            { title: "บริการที่ลูกค้าใช้", width: { wpx: 90 } },
            { title: "ชื่อผู้ติดต่อ 2", width: { wpx: 90 } },
            { title: "เบอร์โทรติดต่อ 2", width: { wpx: 90 } },
            { title: "email", width: { wpx: 90 } },
            { title: "ตำแหน่ง", width: { wpx: 90 } },
            { title: "บริการที่ลูกค้าใช้", width: { wpx: 90 } },
            { title: "เกรดลูกค้า", width: { wpx: 90 } },
            { title: "ชื่อฝ่ายขาย", width: { wpx: 90 } },
            { title: "เบอร์โทรติดต่อ", width: { wpx: 90 } },
            { title: "email", width: { wpx: 90 } },
            { title: "Note ฝ่ายขาย", width: { wpx: 90 } },
            { title: "วันที่บันทึก note", width: { wpx: 90 } },
            { title: "ชื่อ Call center", width: { wpx: 90 } },
            { title: "Note Call center", width: { wpx: 90 } },
            { title: "วันที่ บันทึก Note", width: { wpx: 90 } },
            { title: "เกรดทางบัญชี", width: { wpx: 90 } },
            { title: "ชื่อผู้รับวางบิล", width: { wpx: 90 } },
            { title: "สถานที่รับวางบิล", width: { wpx: 90 } },
            { title: "วันที่วางบิล", width: { wpx: 90 } },
            { title: "วันที่รับเช็ค", width: { wpx: 90 } },
            { title: "ชื่อเจ้าหน้าที่การเงิน", width: { wpx: 90 } },
            { title: "เบอร์ติดต่อ", width: { wpx: 90 } },
            { title: "email", width: { wpx: 90 } }
          ],
          data: [
            [
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              },
              {
                value: "",
                style: { font: { sz: "16", bold: true, name: "Cordia New" } }
              }
            ]
          ]
        }
      ]
    };

    this.toggledatatable = this.toggledatatable.bind(this);
    this.toggleReceiveEmail = this.toggleReceiveEmail.bind(this);
    this.toggleUpload = this.toggleUpload.bind(this);
    this.toggleExport = this.toggleExport.bind(this);
    this.toggleAddnote = this.toggleAddnote.bind(this);
    this.toggleDeleteCompany = this.toggleDeleteCompany.bind(this);
    this.toggleNotify = this.toggleNotify.bind(this);
    this.toggleChangeStatus = this.toggleChangeStatus.bind(this);
    this.toggleSearch = this.toggleSearch.bind(this);
    this.showContactModal = this.showContactModal.bind(this);
    this.getSales = this.getSales.bind(this);
    this.getContactMunkong = this.getContactMunkong.bind(this);
    this.handleChangeStatus = this.handleChangeStatus.bind(this);
    this.AddNote = this.AddNote.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.handleChangeInputSec = this.handleChangeInputSec.bind(this);
    this.updateSecData = this.updateSecData.bind(this);
    this.changeStatusOK = this.changeStatusOK.bind(this);
    this.handleSelectSaleSec3 = this.handleSelectSaleSec3.bind(this);
    this.changeSendInfo = this.changeSendInfo.bind(this);
    this.exportStatus = this.exportStatus.bind(this);
    this.importExcel = this.importExcel.bind(this);
    this.handleChangeInputDate = this.handleChangeInputDate.bind(this);
    this.addNoti = this.addNoti.bind(this);
    this.handleSelectSaleExport = this.handleSelectSaleExport.bind(this);
    this.handleChangeCS = this.handleChangeCS.bind(this);
    this.getCallCenters();
    //console.log(props.location.pathname.split("/")[2]);
    // this.setState({
    //   page: 5
    // });
  }
  handleSelectSaleExport = event =>{
    this.setState({
      selectSaleExport: event.target.value
    },()=>{
      this.checkboxExport("1");
    })
  }
  addNoti(){
    let status = "";
    if(this.state.tmp_contact.status === "0"){
      status = "สถานะ 0 - ยังไม่มีการติดต่อ"
    }
    else if(this.state.tmp_contact.status === "1.1"){
      status = "สถานะ 1.1 - ยังไม่สนใจ"
    }
    else if(this.state.tmp_contact.status === "1.2"){
      status = "สถานะ 1.2 - Call Center ติดตาม  "
    }
    else if(this.state.tmp_contact.status === "1.3"){
      status = "สถานะ 1.3 - ส่งข้อมูล"
    }
    else if(this.state.tmp_contact.status === "1.4"){
      status = "สถานะ 1.4 - ลูกค้าให้เข้าพบ"
    }
    else if(this.state.tmp_contact.status === "2"){
      status = "สถานะ 2 - เข้าพบลูกค้าแล้ว"
    }
    else if(this.state.tmp_contact.status === "3"){
      status = "สถานะ 3 - เสนอราคา"
    }
    else if(this.state.tmp_contact.status === "4"){
      status = "สถานะ 4 - เกิดการสั่งซื้อ"
    }
    else if(this.state.tmp_contact.status === "5"){
      status = "สถานะ 5 - ซื้อซ้ำ"
    }
    this.toggleNotify();
    const params = {
      token: localStorage.getItem("token"),
      date: this.state.daten,
      time: this.state.timen,
      textOneChat: `สถานะ: ${status}
ชื่อบริษัท: ${this.state.tmp_contact.company_thname}
ชื่อลูกค้า: ${this.state.tmp_contact.contact_name}
เบอร์โทรศัพท์: ${this.state.tmp_contact.contact_no}
ข้อความแจ้งเตือน: ${this.state.txtnoti}`,
      status: this.state.tmp_contact.status,
      ct_id:this.state.tmp_contact.ct_running,
      text: this.state.txtnoti
    };
    axios
        .post(conf.url + "/notification", params, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(res => {
          
          Swal.fire({
            type: "success",
            title: "ทำรายการสำเร็จ",
            text: "Update ข้อมูลเรียบร้อยแล้ว",
            allowOutsideClick: () => false
          });

          this.getNote(this.state.tmp_contact.ct_running);
        });
   
  }
  importExcel() {
    var file = document.querySelector("#importExcel");
    readXlsxFile(file.files[0]).then(rows => {
      // `rows` is an array of rows
      // each row being an array of cells.
      alert("ดำเนินการ " + rows.length + " รายการ");
    });
  }
  changeSendInfo = event => {
    let checkOK = window.confirm("คุณต้องการเปลี่ยนสถานะการส่งข้อมูล ?");
    if (checkOK === true) {
      let tmp_contact = this.state.tmp_contact;
      tmp_contact.send_info = tmp_contact.send_info === "Y" ? "N" : "Y";
      const params = {
        token: localStorage.getItem("token"),
        ct_id: tmp_contact.ct_running,
        send_info: tmp_contact.send_info
      };
      axios
        .put(conf.url + "/info", params, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(res => {
          this.setState(
            {
              tmp_contact: tmp_contact
            },
            () => {
              this.getContactMunkong(
                this.state.selectsale,
                this.state.selectall
              );
            }
          );
          // console.log(res.data);
        });
    }
  };

  componentDidMount() {
    this.getContactMunkong("all", "all");
    this.getSales();
    
  }
  checkboxExport(type) {
    if (type === "all") {
      if (this.state.exportAll === false) {
        this.setState({
          exportAll: true,
          export0: true,
          export1: true,
          export11: true,
          export12: true,
          export13: true,
          export14: true,
          export2: true,
          export3: true,
          export4: true,
          export5: true
        });
        this.exportDelay(this.state.dataFind);
      } else {
        let data = [];
        this.setState({
          exportAll: false,
          export0: false,
          export1: false,
          export11: false,
          export12: false,
          export13: false,
          export14: false,
          export2: false,
          export3: false,
          export4: false,
          export5: false
        });
        this.exportDelay(data);
      }
    } else {
      this.setState(
        {
          [type]: !this.state[type],
          exportAll: false
        },
        () => {
          let tmpDataFind = this.state.dataFind;
          if (this.state.export0 === false) {
            tmpDataFind = tmpDataFind.filter(function(data) {
              if (data.status === "0") {
                return false;
              } else return true;
            });
          }
          if (this.state.export11 === false) {
            tmpDataFind = tmpDataFind.filter(function(data) {
              if (data.status === "1.1") return false;
              else return true;
            });
          }
          if (this.state.export12 === false) {
            tmpDataFind = tmpDataFind.filter(function(data) {
              if (data.status === "1.2") return false;
              else return true;
            });
          }
          if (this.state.export13 === false) {
            tmpDataFind = tmpDataFind.filter(function(data) {
              if (data.status === "1.3") return false;
              else return true;
            });
          }
          if (this.state.export14 === false) {
            tmpDataFind = tmpDataFind.filter(function(data) {
              if (data.status === "1.4") return false;
              else return true;
            });
          }
          if (this.state.export2 === false) {
            tmpDataFind = tmpDataFind.filter(function(data) {
              if (data.status === "2") return false;
              else return true;
            });
          }
          if (this.state.export3 === false) {
            tmpDataFind = tmpDataFind.filter(function(data) {
              if (data.status === "3") return false;
              else return true;
            });
          }
          if (this.state.export4 === false) {
            tmpDataFind = tmpDataFind.filter(function(data) {
              if (data.status === "4") return false;
              else return true;
            });
          }
          if (this.state.export5 === false) {
            tmpDataFind = tmpDataFind.filter(function(data) {
              if (data.status === "5") return false;
              else return true;
            });
          }

          this.exportDelay(tmpDataFind);
        }
      );
    }
  }
  getCallCenters() {
    axios
      .get(conf.url + "/callcenter", {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(res => {
        //console.log(res);
        let callcenter = res.data.data.map((data, index) => {
          return (
            <MenuItem
              tel={data.actelephone}
              key={index}
              value={data.acfirstname + " " + data.aclastname}
            >
              {data.acfirstname + " " + data.aclastname}
            </MenuItem>
          );
        });
        this.setState({
          callcenter: callcenter
        });
      });
  }

  deleteCompany() {
    this.toggledatatable();
    this.toggleDeleteCompany();
    const params = {
      token: localStorage.getItem("token")
    };
    axios
      .post(
        conf.url + "/contact/delete/" + this.state.tmp_contact.ct_running,
        params,
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
      .then(res => {})
      .then(() => {
        this.getContactMunkong(this.state.selectsale, this.state.selectall);
      });
  }
  changeStatusOK() {
    this.updateStatus(
      this.state.status,
      this.state.tmp_contact.ct_running,
      this.state.tmp_contact.status
    );
  }
  handleChangeInput = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleChangeInputDate = event => {
    this.setState({ [event.target.name]: event.target.value }, () => {
      let tmpDataFind = this.state.dataFind;
      if (this.state.export0 === false) {
        tmpDataFind = tmpDataFind.filter(function(data) {
          if (data.status === "0") {
            return false;
          } else return true;
        });
      }
      if (this.state.export11 === false) {
        tmpDataFind = tmpDataFind.filter(function(data) {
          if (data.status === "1.1") return false;
          else return true;
        });
      }
      if (this.state.export12 === false) {
        tmpDataFind = tmpDataFind.filter(function(data) {
          if (data.status === "1.2") return false;
          else return true;
        });
      }
      if (this.state.export13 === false) {
        tmpDataFind = tmpDataFind.filter(function(data) {
          if (data.status === "1.3") return false;
          else return true;
        });
      }
      if (this.state.export14 === false) {
        tmpDataFind = tmpDataFind.filter(function(data) {
          if (data.status === "1.4") return false;
          else return true;
        });
      }
      if (this.state.export2 === false) {
        tmpDataFind = tmpDataFind.filter(function(data) {
          if (data.status === "2") return false;
          else return true;
        });
      }
      if (this.state.export3 === false) {
        tmpDataFind = tmpDataFind.filter(function(data) {
          if (data.status === "3") return false;
          else return true;
        });
      }
      if (this.state.export4 === false) {
        tmpDataFind = tmpDataFind.filter(function(data) {
          if (data.status === "4") return false;
          else return true;
        });
      }
      if (this.state.export5 === false) {
        tmpDataFind = tmpDataFind.filter(function(data) {
          if (data.status === "5") return false;
          else return true;
        });
      }

      this.exportDelay(tmpDataFind);
    });
  };
  exportStatus() {
    let tmpData = [];
    if (this.state.modalSearch === true) {
      tmpData = JSON.parse(localStorage.getItem("dataFind"));
    } else {
      tmpData = this.state.dataAllInSale;
    }

    this.setState({
      dataFind: tmpData,
      dataFindTmp: tmpData
    });
    this.exportDelay(tmpData);
  }
  exportDelay(tmpData) {
    let dataExcel = [];
    if (tmpData.length === 0) {
      this.setState({
        dataExcel: [
          {
            columns: [
              { title: "สถานะ", width: { wch: 20 } },
              { title: "ID บริษัท", width: { wch: 20 } },
              { title: "ชื่อภาษาไทย", width: { wch: 40 } },
              { title: "ชื่อภาษาอังกฤษ", width: { wch: 40 } },
              { title: "เลขประจำตัวผู้เสียภาษี", width: { wch: 30 } },
              { title: "กลุ่มของบริษัท (ชื่อภาษาไทย)", width: { wpx: 90 } },
              { title: "กลุ่มของบริษัท (ชื่อภาษาอังกฤษ)", width: { wpx: 90 } },
              { title: "ID บริษัทสำนักงานใหญ่", width: { wpx: 90 } },
              { title: "บ้านเลขที่", width: { wpx: 90 } },
              { title: "หมู่", width: { wpx: 90 } },
              { title: "ซอย", width: { wpx: 90 } },
              { title: "หมูบ้าน", width: { wpx: 90 } },
              { title: "ถนน", width: { wpx: 90 } },
              { title: "แขวง/ตำบล", width: { wpx: 90 } },
              { title: "เขต/อำเภอ", width: { wpx: 90 } },
              { title: "จังหวัด", width: { wpx: 90 } },
              { title: "รหัสไปรษณีย์", width: { wpx: 90 } },
              { title: "เบอร์โทรศัพท์ 1", width: { wpx: 90 } },
              { title: "เบอร์โทรศัพท์ 2", width: { wpx: 90 } },
              { title: "ชื่อผู้ติดต่อ 1", width: { wpx: 90 } },
              { title: "เบอร์โทรติดต่อ 1", width: { wpx: 90 } },
              { title: "Email", width: { wpx: 90 } },
              { title: "ตำแหน่ง", width: { wpx: 90 } },
              { title: "บริการที่ลูกค้าใช้", width: { wpx: 90 } },
              { title: "ชื่อผู้ติดต่อ 2", width: { wpx: 90 } },
              { title: "เบอร์โทรติดต่อ 2", width: { wpx: 90 } },
              { title: "email", width: { wpx: 90 } },
              { title: "ตำแหน่ง", width: { wpx: 90 } },
              { title: "บริการที่ลูกค้าใช้", width: { wpx: 90 } },
              { title: "เกรดลูกค้า", width: { wpx: 90 } },
              { title: "ชื่อฝ่ายขาย", width: { wpx: 90 } },
              { title: "เบอร์โทรติดต่อ", width: { wpx: 90 } },
              { title: "email", width: { wpx: 90 } },
              { title: "Note ฝ่ายขาย", width: { wpx: 90 } },
              { title: "วันที่บันทึก note", width: { wpx: 90 } },
              { title: "ชื่อ Call center", width: { wpx: 90 } },
              { title: "Note Call center", width: { wpx: 90 } },
              { title: "วันที่ บันทึก Note", width: { wpx: 90 } },
              { title: "เกรดทางบัญชี", width: { wpx: 90 } },
              { title: "ชื่อผู้รับวางบิล", width: { wpx: 90 } },
              { title: "สถานที่รับวางบิล", width: { wpx: 90 } },
              { title: "วันที่วางบิล", width: { wpx: 90 } },
              { title: "วันที่รับเช็ค", width: { wpx: 90 } },
              { title: "ชื่อเจ้าหน้าที่การเงิน", width: { wpx: 90 } },
              { title: "เบอร์ติดต่อ", width: { wpx: 90 } },
              { title: "email", width: { wpx: 90 } }
            ],
            data: []
          }
        ]
      });
    }
    tmpData.map(res => {
      let checkpush = true;
      if (
        this.state.dateStart !== undefined &&
        this.state.dateEnd !== undefined
      ) {
        let dateStart = new Date(this.state.dateStart).setHours(0, 0, 0, 0, 0);
        let dateEnd = new Date(this.state.dateEnd).setHours(0, 0, 0, 0, 0);
        let curTime = new Date(res.upd_date).setHours(0, 0, 0, 0, 0);

        if (curTime < dateStart || curTime > dateEnd) {
          checkpush = false;
        }
      }
      if(res.bill_create_date === "2000-01-01"){
        res.bill_create_date = "-"
       }
      if (checkpush === true){
        let checkpushSale = true;
        if(this.state.selectSaleExport !== 'all'){
          if(this.state.selectSaleExport !== res.sales_id){
            checkpushSale = false
          }
        }
        if(checkpushSale === true)
        dataExcel.push([
          {
            value: res.status !== null || res.status !== "" ? res.status : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.account_no !== null && res.account_no !== ""
                ? res.account_no
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.company_thname !== null && res.company_thname !== ""
                ? res.company_thname
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.company_enname !== null && res.company_enname !== ""
                ? res.company_enname
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value: res.tax_id !== null && res.tax_id !== "" ? res.tax_id : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.group_thname !== null && res.group_thname !== ""
                ? res.group_thname
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.group_enname !== null && res.group_enname !== ""
                ? res.group_enname
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.company_id !== null && res.company_id !== ""
                ? res.company_id
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.address_no !== null && res.address_no !== ""
                ? res.address_no
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value: res.moo !== null && res.moo !== "" ? res.moo : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value: res.soi !== null && res.soi !== "" ? res.soi : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value: res.vilage !== null && res.vilage !== "" ? res.vilage : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value: res.road !== null && res.road !== "" ? res.road : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.subdistrict !== null && res.subdistrict !== ""
                ? res.subdistrict
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.district !== null && res.district !== "" ? res.district : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.province !== null && res.province !== "" ? res.province : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.zipcode !== null && res.zipcode !== "" ? res.zipcode : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.telephone1 !== null && res.telephone1 !== ""
                ? res.telephone1
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.telephone2 !== null && res.telephone2 !== ""
                ? res.telephone2
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.contact_name !== null && res.contact_name !== ""
                ? res.contact_name
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.contact_no !== null && res.contact_no !== ""
                ? res.contact_no
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.contact_email !== null && res.contact_email !== ""
                ? res.contact_email
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value: "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.customer_product !== null && res.customer_product !== ""
                ? res.customer_product
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.contact_name_2 !== null && res.contact_name_2 !== ""
                ? res.contact_name_2
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.contact_no_2 !== null && res.contact_no_2 !== ""
                ? res.contact_no_2
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.contact_email_2 !== null && res.contact_email_2 !== ""
                ? res.contact_email_2
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value: "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.customer_product_2 !== null && res.customer_product_2 !== ""
                ? res.customer_product_2
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value: res.grade !== null && res.grade !== "" ? res.grade : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.acfirstname !== null && res.acfirstname !== ""
                ? res.acfirstname + " " + res.aclastname
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.actelephone !== null && res.actelephone !== ""
                ? res.actelephone
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.acemail !== null && res.acemail !== "" ? res.acemail : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.sale_noted !== null && res.sale_noted !== ""
                ? res.sale_noted
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.sale_noted_date !== null && res.sale_noted_date !== ""
                ? res.sale_noted_date
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.call_center_name !== null && res.call_center_name !== ""
                ? res.call_center_name
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.call_center_noted !== null && res.call_center_noted !== ""
                ? res.call_center_noted
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.call_center_note_date !== null &&
              res.call_center_note_date !== ""
                ? res.call_center_note_date
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.financial_grade !== null && res.financial_grade !== ""
                ? res.financial_grade
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.financial_code !== null && res.financial_code !== ""
                ? res.financial_code
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.billing_name !== null && res.billing_name !== ""
                ? res.billing_name
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.billing_place !== null && res.billing_place !== ""
                ? res.billing_place
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.bill_create_date !== null && res.bill_create_date !== ""
                ? res.bill_create_date
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.cheque_receive_date !== null && res.cheque_receive_date !== ""
                ? res.cheque_receive_date
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.financial_contact_name !== null &&
              res.financial_contact_name !== ""
                ? res.financial_contact_name
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.financial_contact_phone !== null &&
              res.financial_contact_phone !== ""
                ? res.financial_contact_phone
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          },
          {
            value:
              res.financial_contact_email !== null &&
              res.financial_contact_email !== ""
                ? res.financial_contact_email
                : "-",
            style: { font: { sz: "16", bold: true, name: "Cordia New" } }
          }
        ]);
      }
        
      this.setState({
        dataExcel: [
          {
            columns: [
              { title: "สถานะ", width: { wch: 20 } },
              { title: "ID บริษัท", width: { wch: 20 } },
              { title: "ชื่อภาษาไทย", width: { wch: 40 } },
              { title: "ชื่อภาษาอังกฤษ", width: { wch: 40 } },
              { title: "เลขประจำตัวผู้เสียภาษี", width: { wch: 30 } },
              { title: "กลุ่มของบริษัท (ชื่อภาษาไทย)", width: { wpx: 90 } },
              { title: "กลุ่มของบริษัท (ชื่อภาษาอังกฤษ)", width: { wpx: 90 } },
              { title: "ID บริษัทสำนักงานใหญ่", width: { wpx: 90 } },
              { title: "บ้านเลขที่", width: { wpx: 90 } },
              { title: "หมู่", width: { wpx: 90 } },
              { title: "ซอย", width: { wpx: 90 } },
              { title: "หมูบ้าน", width: { wpx: 90 } },
              { title: "ถนน", width: { wpx: 90 } },
              { title: "แขวง/ตำบล", width: { wpx: 90 } },
              { title: "เขต/อำเภอ", width: { wpx: 90 } },
              { title: "จังหวัด", width: { wpx: 90 } },
              { title: "รหัสไปรษณีย์", width: { wpx: 90 } },
              { title: "เบอร์โทรศัพท์ 1", width: { wpx: 90 } },
              { title: "เบอร์โทรศัพท์ 2", width: { wpx: 90 } },
              { title: "ชื่อผู้ติดต่อ 1", width: { wpx: 90 } },
              { title: "เบอร์โทรติดต่อ 1", width: { wpx: 90 } },
              { title: "Email", width: { wpx: 90 } },
              { title: "ตำแหน่ง", width: { wpx: 90 } },
              { title: "บริการที่ลูกค้าใช้", width: { wpx: 90 } },
              { title: "ชื่อผู้ติดต่อ 2", width: { wpx: 90 } },
              { title: "เบอร์โทรติดต่อ 2", width: { wpx: 90 } },
              { title: "email", width: { wpx: 90 } },
              { title: "ตำแหน่ง", width: { wpx: 90 } },
              { title: "บริการที่ลูกค้าใช้", width: { wpx: 90 } },
              { title: "เกรดลูกค้า", width: { wpx: 90 } },
              { title: "ชื่อฝ่ายขาย", width: { wpx: 90 } },
              { title: "เบอร์โทรติดต่อ", width: { wpx: 90 } },
              { title: "email", width: { wpx: 90 } },
              { title: "Note ฝ่ายขาย", width: { wpx: 90 } },
              { title: "วันที่บันทึก note", width: { wpx: 90 } },
              { title: "ชื่อ Call center", width: { wpx: 90 } },
              { title: "Note Call center", width: { wpx: 90 } },
              { title: "วันที่ บันทึก Note", width: { wpx: 90 } },
              { title: "เกรดทางบัญชี", width: { wpx: 90 } },
              { title: "ชื่อผู้รับวางบิล", width: { wpx: 90 } },
              { title: "สถานที่รับวางบิล", width: { wpx: 90 } },
              { title: "วันที่วางบิล", width: { wpx: 90 } },
              { title: "วันที่รับเช็ค", width: { wpx: 90 } },
              { title: "ชื่อเจ้าหน้าที่การเงิน", width: { wpx: 90 } },
              { title: "เบอร์ติดต่อ", width: { wpx: 90 } },
              { title: "email", width: { wpx: 90 } }
            ],
            data: dataExcel
          }
        ]
      });
    });
  }
  updateSecData(sec) {
    //console.log(this.state.tmp_contact);

    const params = {
      token: localStorage.getItem("token"),
      sec: sec,
      data: this.state.tmp_contact
    };
    axios
      .put(conf.url + "/contact", JSON.stringify(params), {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(res => {
        this.setState({
          Loading: false
        });
        console.log(res.data.msg);
        if (res.data.msg === "duplicate") {
          Swal.fire({
            type: "error",
            title: "ผิดพลาด",
            text: "ไม่สามารถ Update ข้อมูลได้ เนื่องจาก Tax ID ซ้ำ"
          });
        } else if (res.status === 200) {
          let dataChange = this.state.dataAll;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
            }
          });

          dataChange = this.state.data1;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
            }
          });

          dataChange = this.state.data1_1;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
            }
          });

          dataChange = this.state.data1_2;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
            }
          });

          dataChange = this.state.data1_3;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
            }
          });

          dataChange = this.state.data1_4;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
            }
          });

          dataChange = this.state.data2;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
            }
          });

          dataChange = this.state.data3;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
            }
          });

          dataChange = this.state.data4;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
            }
          });

          dataChange = this.state.data5;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
            }
          });

          dataChange = this.state.data0;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
            }
          });

          if (sec === "1") {
            this.setState({
              openEditSec1: false
            });
          } else if (sec === "2") {
            this.setState({
              openEditSec2: false
            });
          } else if (sec === "3") {
            this.setState({
              openEditSec3: false
            });
          } else if (sec === "4") {
            this.setState({
              openEditSec4: false
            });
          }
          Swal.fire({
            type: "success",
            title: "ทำรายการสำเร็จ",
            text: "Update ข้อมูลเรียบร้อยแล้ว",
            allowOutsideClick: () => false
          });
        } else {
          console.log(res);
          Swal.fire({
            type: "error",
            title: "ผิดพลาด",
            text: "ไม่สามารถ Update ข้อมูลได้",
            allowOutsideClick: () => false
          });
        }
      })
      .catch(er => {
        console.log(er);
        this.setState({
          Loading: false
        });
        Swal.fire({
          type: "error",
          title: "ผิดพลาด",
          text: "ไม่สามารถ Update ข้อมูลได้"
        });
      });
  }
  handleChangeInputSec = event => {
    let tmp_contact = this.state.tmp_contact;
    tmp_contact[event.target.name] = event.target.value;
    this.setState({ tmp_contact: tmp_contact });
  };
  handleChangeCS = event => {
    this.setState({
      tmp_account_no: event.target.value
    })
  }
  sendEmail() {
    const params = {
      token: localStorage.getItem("token"),
      data: this.state.tmp_contact
    };
    axios
      .post(conf.url + "/mail", JSON.stringify(params), {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(res => {
        let tmpChangemail = this.state.tmp_contact;
        tmpChangemail.send_info  = "Y";
        let dataChange = this.state.dataAll;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
            }
          });

          dataChange = this.state.data1;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
            }
          });

          dataChange = this.state.data1_1;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
            }
          });

          dataChange = this.state.data1_2;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
            }
          });

          dataChange = this.state.data1_3;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
            }
          });

          dataChange = this.state.data1_4;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
            }
          });

          dataChange = this.state.data2;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
            }
          });

          dataChange = this.state.data3;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
            }
          });

          dataChange = this.state.data4;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
            }
          });

          dataChange = this.state.data5;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
            }
          });

          dataChange = this.state.data0;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
            }
          });
        //Send Email
        //console.log(res)
        Swal.fire({
          type: "success",
          title: "ทำรายการสำเร็จ",
          text: "ทำรายการสำเร็จ",
          allowOutsideClick: () => false
        });
        this.setState({
          Loading: false
        });
      })
      .catch(er => {
        this.setState({
          Loading: false
        });
      });
  }

  getSales() {
    let user = JSON.parse(localStorage.getItem("data"));
    axios
      .get(conf.url + "/sale", {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(res => {
        let sales = res.data.data.map((data, index) => {
          return (
            <MenuItem key={index} value={data.acusername}>
              {data.acfirstname + " " + data.aclastname}
            </MenuItem>
          );
        });

        this.setState({
          sales: sales,
          sales_data: res.data.data
        });
      })
      .then(() => {
        this.setState({
          user: user
        });
      });
  }

  getContactMunkong(sale, type) {
    this.setState({
      Loading: true
    });
    const params = {
      token: localStorage.getItem("token"),
      sale_id: sale,
      type: type
    };
    axios
      .post(conf.url + "/contact/get", JSON.stringify(params), {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(res => {
        if (type === "all") {
          this.setState({
            data0: [],
            data1: [],
            data1_1: [],
            data1_2: [],
            data1_3: [],
            data1_4: [],
            data2: [],
            data3: [],
            data4: [],
            data5: [],
            dataAllInSale: res.data.data,
           // dataAll: res.data.data
          });
        } else {
          this.setState({
            data1_3: []
          });
        }

        let data0 = [];
        let data1 = [];
        let data1_1 = [];
        let data1_2 = [];
        let data1_3 = [];
        let data1_4 = [];
        let data2 = [];
        let data3 = [];
        let data4 = [];
        let data5 = [];
        res.data.data.map(data => {
          if(data.sale_name === "None"){
            data.sale_name = ""
            data.sales_id = ""
          }
          if (data.status === "0") {
            data0.push(data);
          } else if (
            data.status === "1" ||
            data.status === "1.1" ||
            data.status === "1.2" ||
            data.status === "1.3" ||
            data.status === "1.4"
          ) {
            data1.push(data);
            if (data.status === "1.1") {
              data1_1.push(data);
            } else if (data.status === "1.2") {
              data1_2.push(data);
            } else if (data.status === "1.3") {
              data1_3.push(data);
            } else if (data.status === "1.4") {
              data1_4.push(data);
            }
          } else if (data.status === "2") {
            data2.push(data);
          } else if (data.status === "3") {
            data3.push(data);
          } else if (data.status === "4") {
            data4.push(data);
          } else if (data.status === "5") {
            data5.push(data);
          }
        });
        if (type === "all") {
          this.setState({
           
            data0: data0,
            data1: data1,
            data1_1: data1_1,
            data1_2: data1_2,
            data1_3: data1_3,
            data1_4: data1_4,
            data2: data2,
            data3: data3,
            data4: data4,
            data5: data5
          });
        } else {
          this.setState({
            data1_3: data1_3
          });
        }
        this.setState({
          Loading: false
        },()=>{
          if(localStorage.getItem("ct_id") !== null){
            res.data.data.map(data=>{
              if(parseInt(localStorage.getItem("ct_id")) === data.ct_running){
                this.showContactModal(data);
                localStorage.removeItem("ct_id");
              }
            })
          }
        });
      })
      .catch(er => {
        this.setState({
          Loading: false
        });
      });

      axios
      .post(conf.url + "/contact/getall", JSON.stringify(params), {
        headers: {
          "Content-Type": "application/json"
        }
      }).then(res=>{
        //console.log(res.data.data)
        this.setState({
          dataAll: res.data.data
        })
      })

  }

  getNote(ct_id) {
    this.setState({
      Loading: true
    });
    const params = {
      token: localStorage.getItem("token")
    };
    axios
      .post(conf.url + "/note/" + ct_id, JSON.stringify(params), {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(res => {
        //console.log(this.state.tmp_contact);
        
        res.data.data.unshift({
          id: -2,
          text: "สร้างลูกค้า",
          status: "-",
          create_by: this.state.tmp_contact.cr_by,
          create_date: this.state.tmp_contact.cr_date,
          doc: "ไม่พบเอกสาร"
        });

        if (
          this.state.tmp_contact.sale_noted !== "" &&
          this.state.tmp_contact.sale_noted !== null
        ) {
          res.data.data.push({
            id: -1,
            text: this.state.tmp_contact.sale_noted,
            status: "ค่าเริ่มต้น",
            create_by: this.state.tmp_contact.sale_name,
            create_date: this.state.tmp_contact.sale_noted_date,
            doc: "ไม่พบเอกสาร"
          });
        }

        if (
          this.state.tmp_contact.call_center_noted !== "" &&
          this.state.tmp_contact.sale_noted !== null
        ) {
          res.data.data.push({
            id: -1,
            text: this.state.tmp_contact.call_center_noted,
            status: "ค่าเริ่นต้น",
            create_by: this.state.tmp_contact.call_center_name,
            create_date: this.state.tmp_contact.call_center_note_date,
            doc: "ไม่พบเอกสาร"
          });
        }

        this.setState({
          notes: res.data.data
        },()=>{
           console.log(res.data.data)
        });
        this.setState({
          Loading: false
        });
      })
      .catch(er => {
        this.setState({
          Loading: false
        });
      });
  }
  AddNote() {
    this.toggleAddnote();
    this.setState({
      Loading: true
    });

    const params = {
      token: localStorage.getItem("token"),
      msg: this.state.note,
      status: this.state.tmp_contact.status,
      ct_id: this.state.tmp_contact.ct_running
    };
    const json = JSON.stringify(params);
    const blob = new Blob([json], {
      type: "application/json"
    });
    let formData = new FormData();
    var file = document.querySelector("#noteFile");
    if (file.files[0] === undefined) {
      axios
        .post(conf.url + "/note", params, {
          headers: {
            "Content-Type": "application/json"
          }
        })
        .then(res => {
          this.setState({
            Loading: false
          });
          if (res.status === 200) {
            this.setState({
              note: ""
            });
            this.getNote(this.state.tmp_contact.ct_running);
            Swal.fire({
              type: "success",
              title: "ทำรายการสำเร็จ",
              text: "เพิ่ม note เรียบร้อย",
              allowOutsideClick: () => false
            });
          }
        })
        .catch(er => {
          Swal.fire({
            type: "error",
            title: "ผิดพลาด",
            text: "ไม่สามารถเพิ่มโน๊ตได้",
            allowOutsideClick: () => false
          });
          this.setState({
            Loading: false
          });
        });
    } else {
      formData.append("file", file.files[0]);
      formData.append("data", blob);
      axios
        .post(conf.url + "/note", formData)
        .then(res => {
          this.setState({
            Loading: false
          });
          if (res.status === 200) {
            this.setState({
              note: ""
            });
            this.getNote(this.state.tmp_contact.ct_running);
            Swal.fire({
              type: "success",
              title: "ทำรายการสำเร็จ",
              text: "เพิ่ม note เรียบร้อย",
              allowOutsideClick: () => false
            });
          }
        })
        .catch(er => {
          Swal.fire({
            type: "error",
            title: "ผิดพลาด",
            text: "ไม่สามารถเพิ่มโน๊ตได้",
            allowOutsideClick: () => false
          });
          this.setState({
            Loading: false
          });
        });
    }
  }
  cancelEdit(ct_id) {
    this.setState({
      openEditSec1: false,
      openEditSec2: false,
      openEditSec3: false,
      openEditSec4: false
    });
    this.state.dataAll.map(data => {
      if (data.ct_running === ct_id) {
        let dummyData = JSON.stringify(data);
        this.setState({
          tmp_contact: JSON.parse(dummyData)
        });
      }
    });
    this.state.data1.map(data => {
      if (data.ct_running === ct_id) {
        let dummyData = JSON.stringify(data);
        this.setState({
          tmp_contact: JSON.parse(dummyData)
        });
      }
    });
    this.state.data1_1.map(data => {
      if (data.ct_running === ct_id) {
        let dummyData = JSON.stringify(data);
        this.setState({
          tmp_contact: JSON.parse(dummyData)
        });
      }
    });
    this.state.data1_2.map(data => {
      if (data.ct_running === ct_id) {
        let dummyData = JSON.stringify(data);
        this.setState({
          tmp_contact: JSON.parse(dummyData)
        });
      }
    });
    this.state.data1_3.map(data => {
      if (data.ct_running === ct_id) {
        let dummyData = JSON.stringify(data);
        this.setState({
          tmp_contact: JSON.parse(dummyData)
        });
      }
    });
    this.state.data1_4.map(data => {
      if (data.ct_running === ct_id) {
        let dummyData = JSON.stringify(data);
        this.setState({
          tmp_contact: JSON.parse(dummyData)
        });
      }
    });
    this.state.data2.map(data => {
      if (data.ct_running === ct_id) {
        let dummyData = JSON.stringify(data);
        this.setState({
          tmp_contact: JSON.parse(dummyData)
        });
      }
    });
    this.state.data3.map(data => {
      if (data.ct_running === ct_id) {
        let dummyData = JSON.stringify(data);
        this.setState({
          tmp_contact: JSON.parse(dummyData)
        });
      }
    });
    this.state.data4.map(data => {
      if (data.ct_running === ct_id) {
        let dummyData = JSON.stringify(data);
        this.setState({
          tmp_contact: JSON.parse(dummyData)
        });
      }
    });
    this.state.data5.map(data => {
      if (data.ct_running === ct_id) {
        let dummyData = JSON.stringify(data);
        this.setState({
          tmp_contact: JSON.parse(dummyData)
        });
      }
    });

    this.state.data0.map(data => {
      if (data.ct_running === ct_id) {
        let dummyData = JSON.stringify(data);
        this.setState({
          tmp_contact: JSON.parse(dummyData)
        });
      }
    });
  }
  showContactModal(data) {
    console.log(data)
    
    if(data.account_no === null || data.account_no === ''){
      data.account_no = ''
      this.setState({
        cs:false
      })
    }else{
      this.setState({
        cs:true
      })
    }
    let tmpData = JSON.stringify(data);
    this.setState({
      tmp_contact: JSON.parse(tmpData),
      status: JSON.parse(tmpData).status,
      selectcallcenter: JSON.parse(tmpData).call_center_name
    });
    this.toggledatatable();
    this.getNote(data.ct_running);
  }

  toggledatatable() {
    if (this.state.modal == true) {
      this.setState({
        openEditSec1: false,
        openEditSec2: false,
        openEditSec3: false,
        openEditSec4: false
      });
    }
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  }

  toggleUpload() {
    this.setState(prevState => ({
      modalUpload: !prevState.modalUpload
    }));
  }

  toggleExport() {
    this.exportStatus();
    this.setState({
      modalExport: !this.state.modalExport,
      exportAll: true,
      export0: true,
      export1: true,
      export11: true,
      export12: true,
      export13: true,
      export14: true,
      export2: true,
      export3: true,
      export4: true,
      export5: true
    });
  }

  toggleDeleteCompany() {
    this.setState({
      modalDeleteCompany: !this.state.modalDeleteCompany
    });
  }

  toggleNotify() {
    this.setState({
      modalNotify: !this.state.modalNotify
    });
  }

  toggleChangeStatus() {
    this.setState({
      modalChangeStatus: !this.state.modalChangeStatus,
      status: this.state.tmp_contact.status
    });
  }

  toggleReceiveEmail() {
    this.setState(prevState => ({
      modalReceiveEmail: !prevState.modalReceiveEmail
    }));
  }

  toggleSearch() {
    this.setState(prevState => ({
      modalSearch: !prevState.modalSearch
    }));
  }

  toggleAddnote() {
    this.setState(prevState => ({
      modalAddnote: !prevState.modalAddnote
    }));
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeIndex = index => {
    this.setState({ value: index });
  };

  handleChangeStatus = event => {
    if (event.target.value !== this.state.status) {
      this.setState({ status: event.target.value,tmp_account_no: this.state.tmp_contact.account_no });
      this.setState({
        modalChangeStatus: !this.state.modalChangeStatus
      });
    }
  };
  updateStatus(status, ct_id, old_status) {
    this.setState({
      Loading: true
    });
    const params = {
      token: localStorage.getItem("token"),
      ct_id: ct_id,
      status: status,
      old_status: old_status,
      name: this.state.tmp_contact.company_thname,
      sale_id: this.state.tmp_contact.sales_id,
      cs: this.state.tmp_account_no
    };

    const json = JSON.stringify(params);
    const blob = new Blob([json], {
      type: "application/json"
    });

    let formData = new FormData();
    let fileOrderFile = document.querySelector("#orderFile");
    let fileProposalFile = document.querySelector("#proposalFile");
    let fileCardFile = document.querySelector("#cardFile");
    let filePriceFile = document.querySelector("#priceFile");

    if (fileProposalFile !== null)
      formData.append("fileProp", fileProposalFile.files[0]);
    if (fileOrderFile !== null)
      formData.append("fileOrder", fileOrderFile.files[0]);
    if (fileCardFile !== null)
      formData.append("fileCard", fileCardFile.files[0]);
    if (filePriceFile !== null)
      formData.append("filePrice", filePriceFile.files[0]);

    formData.append("data", blob);

    axios
      .put(conf.url + "/status", formData)
      .then(res => {
        this.setState({
          Loading: false
        });
        if (res.status === 200) {
          this.setState({
            note: "",
            modalChangeStatus: !this.state.modalChangeStatus
          });
          this.getNote(this.state.tmp_contact.ct_running);

          let dataChange = this.state.dataAll;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
              tmpData.account_no  = this.state.tmp_account_no
              this.setState({
                tmp_contact: tmpData
              })
            }
          });

          dataChange = this.state.data1;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
              tmpData.account_no  = this.state.tmp_account_no
            }
          });

          dataChange = this.state.data1_1;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
              tmpData.account_no  = this.state.tmp_account_no
            }
          });

          dataChange = this.state.data1_2;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
              tmpData.account_no  = this.state.tmp_account_no
            }
          });

          dataChange = this.state.data1_3;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
              tmpData.account_no  = this.state.tmp_account_no
            }
          });

          dataChange = this.state.data1_4;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
              tmpData.account_no  = this.state.tmp_account_no
            }
          });

          dataChange = this.state.data2;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
              tmpData.account_no  = this.state.tmp_account_no
            }
          });

          dataChange = this.state.data3;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
              tmpData.account_no  = this.state.tmp_account_no
            }
          });

          dataChange = this.state.data4;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
              tmpData.account_no  = this.state.tmp_account_no
            }
          });

          dataChange = this.state.data5;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
              tmpData.account_no  = this.state.tmp_account_no
            }
          });

          dataChange = this.state.data0;
          dataChange.map(res => {
            if (res.ct_running === this.state.tmp_contact.ct_running) {
              let tmpData = JSON.stringify(this.state.tmp_contact);
              tmpData = JSON.parse(tmpData);
              Object.keys(res).map(data => {
                res[data] = tmpData[data];
              });
              tmpData.account_no  = this.state.tmp_account_no
            }
          });

          Swal.fire({
            type: "success",
            title: "ทำรายการสำเร็จ",
            text: "Update ข้อมูลเรียบร้อยแล้ว",
            allowOutsideClick: () => false
          });
          this.getContactMunkong(this.state.selectsale, "all");
        } else {
          Swal.fire({
            type: "error",
            title: "ผิดพลาด",
            text: "พบข้อผิดพลาด กรุณาลองใหม่อีกครั้ง",
            allowOutsideClick: () => false
          });
        }
      })
      .catch(er => {
        this.setState({
          Loading: false
        });
        Swal.fire({
          type: "error",
          title: "ผิดพลาด",
          text: "พบข้อผิดพลาด กรุณาลองใหม่อีกครั้ง",
          allowOutsideClick: () => false
        });
      });
  }
  handleSelectSaleSec3 = event => {
    let tmp_contact = this.state.tmp_contact;
    tmp_contact.sales_id = event.target.value;
    this.state.sales_data.map(data => {
      if (data.acusername == event.target.value) {
        tmp_contact.acfirstname = data.acfirstname;
        tmp_contact.aclastname = data.aclastname;
        tmp_contact.acemail = data.acemail;
        tmp_contact.sale_name = data.acfirstname + " " + data.aclastname;
        tmp_contact.actelephone = data.actelephone;
      }
      if (event.target.value === "") {
        tmp_contact.acfirstname = "";
        tmp_contact.aclastname = "";
        tmp_contact.sale_name = "";
        tmp_contact.acemail = "";
        tmp_contact.actelephone = "";
      }
    });
    this.setState({
      tmp_contact: tmp_contact
    });
  };

  handleSelectCallCenterSec3 = event => {
    let tmp_contact = this.state.tmp_contact;
    tmp_contact.call_center_name = event.target.value;
    this.setState({
      [event.target.name]: event.target.value
    });
  };

  handleSelectSale = event => {
    this.setState({
      [event.target.name]: event.target.value,
      selectall: "all"
    });

    this.getContactMunkong(event.target.value, "all");
  };

  handleSelectSale_1_3 = event => {
    this.setState({ [event.target.name]: event.target.value });

    this.getContactMunkong(event.target.value, this.state.selectall);
  };

  handleSelectAll = event => {
    this.setState({ [event.target.name]: event.target.value });

    this.getContactMunkong(this.state.selectsale, event.target.value);
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        {this.state.Loading && (
          <PulseLoader sizeUnit={"px"} size={50} color={"#F48F0C"} />
        )}
        <Row className="mr-1">
          <Col className="col-xs-12 col-sm-6 col-md-6 text-left">
            <Button
              color="secondary"
              style={{ color: "white", padding: "10px" }}
              onClick={this.toggleSearch}
            >
              <Icon className="pt-1">search</Icon> ค้นหาทั้งหมด{" "}
            </Button>{" "}
          </Col>
          <Col className="col-xs-12 col-sm-6 col-md-6 text-right">
            <a href="/addcustomer">
              <Button
                color="success"
                style={{ color: "white", padding: "10px" }}
              >
                <Icon className="pt-1">add</Icon> เพิ่มข้อมูลลูกค้าใหม่{" "}
              </Button>{" "}
            </a>
            {/* <Button
              color="info"
              style={{ color: "white", padding: "10px" }}
              onClick={this.toggleUpload}
            >
              <Icon className="pt-1">cloud_upload</Icon> อัพโหลด{" "}
            </Button>{" "} */}
            <Button
              color="primary"
              style={{ color: "white", padding: "10px" }}
              onClick={this.toggleExport}
            >
              <Icon className="pt-1">exit_to_app</Icon> ส่งออก Excel{" "}
            </Button>{" "}
          </Col>
        </Row>
        <br />
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <CustomTabs
              page={this.props.location.pathname.split("/")[2]}
              title="สถานะทั้งหมด:"
              headerColor="danger"
              tabs={[
                {
                  // สถานะ 0
                  tabName: "สถานะ 0",
                  tabIcon: PersonAddDisabled,
                  tabContent: (
                    <div className="mt-4">
                      <h4>จำนวนลูกค้าทั้งหมด {this.state.data0.length} ราย</h4>

                      <div className="mt-4">
                        <div className="row ml-auto mr-auto justify-content-end">
                          <div className="col-xs-12 col-sm-6 col-md-4 mb-3">
                            <FormControl
                              fullWidth
                              className={classes.selectFormControl}
                            >
                              <InputLabel
                                style={{
                                  display:
                                    this.state.user.acstatus !== "4"
                                      ? "block"
                                      : "none"
                                }}
                                htmlFor="simple-select"
                                className={classes.selectLabel}
                              >
                                เลือกฝ่ายขาย
                              </InputLabel>
                              <Select
                                style={{
                                  display:
                                    this.state.user.acstatus !== "4"
                                      ? "block"
                                      : "none"
                                }}
                                MenuProps={{
                                  className: classes.selectMenu
                                }}
                                classes={{
                                  select: classes.select
                                }}
                                value={this.state.selectsale}
                                onChange={this.handleSelectSale}
                                inputProps={{
                                  name: "selectsale",
                                  id: "selectsale"
                                }}
                              >
                                <MenuItem key={-1} value={"all"}>
                                  {"ทั้งหมด"}
                                </MenuItem>
                                <MenuItem key={-2} value={"none"}>
                                  {"- ไม่มีฝ่ายขาย -"}
                                </MenuItem>
                                {this.state.sales}
                              </Select>
                            </FormControl>
                          </div>
                        </div>
                        <MaterialTable
                          title="สถานะ 0 - ยังไม่มีการติดต่อ"
                          onRowClick={(e, d) => this.showContactModal(d)}
                          columns={[
                            {
                              title: "สถานะ",
                              field: "status",
                              defaultSort: "desc",
                              cellStyle: { width: "1px" }

                              //hidden: true
                            },
                            { title: "ชื่อบริษัท", field: "company_thname" },
                            { title: "ชื่อลูกค้า", field: "contact_name" },
                            { title: "เบอร์ติดต่อ", field: "contact_no" },
                            { title: "อีเมล์", field: "contact_email" },
                            {
                              title: "ชื่อ Call Center",
                              field: "call_center_name"
                            },
                            {
                              title: "ชื่อฝ่ายขาย",
                              field: "sale_name"
                            }
                            // {
                            //   title: "ชื่อฝ่ายขาย",
                            //   render: rowdata => {
                            //     return (
                            //       <div>
                            //         {/* {rowdata.acfirstname === null
                            //           ? "-ไม่มีฝ่ายขาย-"
                            //           : rowdata.acfirstname +
                            //             " " +
                            //             rowdata.aclastname} */}
                            //              {rowdata.sale_name}
                            //       </div>
                            //     );
                            //   }
                            // }
                          ]}
                          data={this.state.data0}
                        />
                      </div>
                    </div>
                  )
                },
                {
                  tabName: "สถานะ 1",
                  tabIcon: ChatBubble,
                  tabContent: (
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={12}>
                        <CustomTabs
                          subPage={this.props.location.pathname.split("/")[3]}
                          title="สถานะ 1:"
                          headerColor="info"
                          tabs={[
                            {
                              tabName: "สถานะ 1",
                              tabContent: (
                                <div className="mt-4">
                                  <h4>
                                    จำนวนลูกค้าทั้งหมด {this.state.data1.length}{" "}
                                    ราย
                                  </h4>
                                  <div className="row ml-auto mr-auto justify-content-end">
                                    <div className="col-xs-12 col-sm-6 col-md-4 mb-3">
                                      <FormControl
                                        fullWidth
                                        className={classes.selectFormControl}
                                      >
                                        <InputLabel
                                          style={{
                                            display:
                                              this.state.user.acstatus !== "4"
                                                ? "block"
                                                : "none"
                                          }}
                                          htmlFor="selectsale"
                                          className={classes.selectLabel}
                                        >
                                          เลือกฝ่ายขาย
                                        </InputLabel>
                                        <Select
                                          style={{
                                            display:
                                              this.state.user.acstatus !== "4"
                                                ? "block"
                                                : "none"
                                          }}
                                          MenuProps={{
                                            className: classes.selectMenu
                                          }}
                                          classes={{
                                            select: classes.select
                                          }}
                                          value={this.state.selectsale}
                                          onChange={this.handleSelectSale}
                                          inputProps={{
                                            name: "selectsale",
                                            id: "selectsale"
                                          }}
                                        >
                                          <MenuItem key={-1} value={"all"}>
                                            {"ทั้งหมด"}
                                          </MenuItem>
                                          <MenuItem key={-2} value={"none"}>
                                            {"- ไม่มีฝ่ายขาย -"}
                                          </MenuItem>
                                          {this.state.sales}
                                        </Select>
                                      </FormControl>
                                    </div>
                                  </div>
                                  <div className="mt-4">
                                    <MaterialTable
                                      onRowClick={(e, d) =>
                                        this.showContactModal(d)
                                      }
                                      columns={[
                                        {
                                          title: "สถานะ",
                                          field: "status",
                                          defaultSort: "desc",
                                          cellStyle: { width: "1px" }
                                        },
                                        {
                                          title: "ชื่อบริษัท",
                                          field: "company_thname"
                                        },
                                        {
                                          title: "ชื่อลูกค้า",
                                          field: "contact_name"
                                        },
                                        {
                                          title: "เบอร์ติดต่อ",
                                          field: "contact_no"
                                        },
                                        {
                                          title: "อีเมล์",
                                          field: "contact_email"
                                        },
                                        {
                                          title: "ชื่อ Call Center",
                                          field: "call_center_name"
                                        },
                                        {
                                          title: "ชื่อฝ่ายขาย",
                                          field: "sale_name"
                                        }
                                        // {
                                        //   title: "ชื่อฝ่ายขาย",
                                        //   render: rowdata => {
                                        //     return (
                                        //       <div>
                                        //         {/* {rowdata.acfirstname === null
                                        //           ? "-ไม่มีฝ่ายขาย-"
                                        //           : rowdata.acfirstname +
                                        //             " " +
                                        //             rowdata.aclastname} */}
                                        //              {rowdata.sale_name}
                                        //       </div>
                                        //     );
                                        //   }
                                        // }
                                      ]}
                                      data={this.state.data1}
                                      title="สถานะ 1 - ยังไม่สนใจ"
                                    />
                                  </div>
                                </div>
                              )
                            },
                            {
                              tabName: "สถานะ 1.1",
                              tabContent: (
                                <div className="mt-4">
                                  <h4>
                                    จำนวนลูกค้าทั้งหมด{" "}
                                    {this.state.data1_1.length} ราย
                                  </h4>
                                  <div className="row ml-auto mr-auto justify-content-end">
                                    <div className="col-xs-12 col-sm-6 col-md-4 mb-3">
                                      <FormControl
                                        fullWidth
                                        className={classes.selectFormControl}
                                      >
                                        <InputLabel
                                          style={{
                                            display:
                                              this.state.user.acstatus !== "4"
                                                ? "block"
                                                : "none"
                                          }}
                                          htmlFor="selectsale"
                                          className={classes.selectLabel}
                                        >
                                          เลือกฝ่ายขาย
                                        </InputLabel>
                                        <Select
                                          style={{
                                            display:
                                              this.state.user.acstatus !== "4"
                                                ? "block"
                                                : "none"
                                          }}
                                          MenuProps={{
                                            className: classes.selectMenu
                                          }}
                                          classes={{
                                            select: classes.select
                                          }}
                                          value={this.state.selectsale}
                                          onChange={this.handleSelectSale}
                                          inputProps={{
                                            name: "selectsale",
                                            id: "selectsale"
                                          }}
                                        >
                                          <MenuItem key={-1} value={"all"}>
                                            {"ทั้งหมด"}
                                          </MenuItem>
                                          <MenuItem key={-2} value={"none"}>
                                            {"- ไม่มีฝ่ายขาย -"}
                                          </MenuItem>
                                          {this.state.sales}
                                        </Select>
                                      </FormControl>
                                    </div>
                                  </div>
                                  <div className="mt-4">
                                    <MaterialTable
                                      onRowClick={(e, d) =>
                                        this.showContactModal(d)
                                      }
                                      columns={[
                                        {
                                          title: "สถานะ",
                                          field: "status",
                                          defaultSort: "desc",
                                          cellStyle: { width: "1px" }
                                        },
                                        {
                                          title: "ชื่อบริษัท",
                                          field: "company_thname"
                                        },
                                        {
                                          title: "ชื่อลูกค้า",
                                          field: "contact_name"
                                        },
                                        {
                                          title: "เบอร์ติดต่อ",
                                          field: "contact_no"
                                        },
                                        {
                                          title: "อีเมล์",
                                          field: "contact_email"
                                        },
                                        {
                                          title: "ชื่อ Call Center",
                                          field: "call_center_name"
                                        },
                                        {
                                          title: "ชื่อฝ่ายขาย",
                                          field: "sale_name"
                                        }
                                        // {
                                        //   title: "ชื่อฝ่ายขาย",
                                        //   render: rowdata => {
                                        //     return (
                                        //       <div>
                                        //         {/* {rowdata.acfirstname === null
                                        //           ? "-ไม่มีฝ่ายขาย-"
                                        //           : rowdata.acfirstname +
                                        //             " " +
                                        //             rowdata.aclastname} */}
                                        //              {rowdata.sale_name}
                                        //       </div>
                                        //     );
                                        //   }
                                        // }
                                      ]}
                                      data={this.state.data1_1}
                                      title="สถานะ 1.1 - ยังไม่สนใจ"
                                    />
                                  </div>
                                </div>
                              )
                            },
                            {
                              tabName: "สถานะ 1.2",
                              tabContent: (
                                <div className="mt-4">
                                  <h4>
                                    จำนวนลูกค้าทั้งหมด{" "}
                                    {this.state.data1_2.length} ราย
                                  </h4>
                                  <div className="row ml-auto mr-auto justify-content-end">
                                    <div className="col-xs-12 col-sm-6 col-md-4 mb-3">
                                      <FormControl
                                        fullWidth
                                        className={classes.selectFormControl}
                                      >
                                        <InputLabel
                                          style={{
                                            display:
                                              this.state.user.acstatus !== "4"
                                                ? "block"
                                                : "none"
                                          }}
                                          htmlFor="selectsale"
                                          className={classes.selectLabel}
                                        >
                                          เลือกฝ่ายขาย
                                        </InputLabel>
                                        <Select
                                          style={{
                                            display:
                                              this.state.user.acstatus !== "4"
                                                ? "block"
                                                : "none"
                                          }}
                                          MenuProps={{
                                            className: classes.selectMenu
                                          }}
                                          classes={{
                                            select: classes.select
                                          }}
                                          value={this.state.selectsale}
                                          onChange={this.handleSelectSale}
                                          inputProps={{
                                            name: "selectsale",
                                            id: "selectsale"
                                          }}
                                        >
                                          <MenuItem key={-1} value={"all"}>
                                            {"ทั้งหมด"}
                                          </MenuItem>
                                          <MenuItem key={-2} value={"none"}>
                                            {"- ไม่มีฝ่ายขาย -"}
                                          </MenuItem>
                                          {this.state.sales}
                                        </Select>
                                      </FormControl>
                                    </div>
                                  </div>
                                  <div className="mt-4">
                                    <MaterialTable
                                      onRowClick={(e, d) =>
                                        this.showContactModal(d)
                                      }
                                      columns={[
                                        {
                                          title: "สถานะ",
                                          field: "status",
                                          defaultSort: "desc",
                                          cellStyle: { width: "1px" }
                                        },
                                        {
                                          title: "ชื่อบริษัท",
                                          field: "company_thname"
                                        },
                                        {
                                          title: "ชื่อลูกค้า",
                                          field: "contact_name"
                                        },
                                        {
                                          title: "เบอร์ติดต่อ",
                                          field: "contact_no"
                                        },
                                        {
                                          title: "อีเมล์",
                                          field: "contact_email"
                                        },
                                        {
                                          title: "ชื่อ Call Center",
                                          field: "call_center_name"
                                        },
                                        {
                                          title: "ชื่อฝ่ายขาย",
                                          field: "sale_name"
                                        }
                                        // {
                                        //   title: "ชื่อฝ่ายขาย",
                                        //   render: rowdata => {
                                        //     return (
                                        //       <div>
                                        //         {/* {rowdata.acfirstname === null
                                        //           ? "-ไม่มีฝ่ายขาย-"
                                        //           : rowdata.acfirstname +
                                        //             " " +
                                        //             rowdata.aclastname} */}
                                        //              {rowdata.sale_name}
                                        //       </div>
                                        //     );
                                        //   }
                                        // }
                                      ]}
                                      data={this.state.data1_2}
                                      title="สถานะ 1.2 - Call Center ติดตาม"
                                    />
                                  </div>
                                </div>
                              )
                            },
                            {
                              tabName: "สถานะ 1.3",
                              tabContent: (
                                <div className="mt-4">
                                  <h4>
                                    จำนวนลูกค้าทั้งหมด{" "}
                                    {this.state.data1_3.length} ราย
                                  </h4>
                                  <div className="row ml-auto mr-auto">
                                    <div className="col-xs-6 col-sm-6 col-md-4 mb-3">
                                      <FormControl
                                        fullWidth
                                        className={classes.selectFormControl}
                                      >
                                        <InputLabel
                                          htmlFor="selectall"
                                          className={classes.selectLabel}
                                        >
                                          สถานะการส่ง
                                        </InputLabel>
                                        <Select
                                          // style={{
                                          //   display:
                                          //     this.state.user.acstatus !== "4"
                                          //       ? "block"
                                          //       : "none"
                                          // }}
                                          MenuProps={{
                                            className: classes.selectMenu
                                          }}
                                          classes={{
                                            select: classes.select
                                          }}
                                          value={this.state.selectall}
                                          onChange={this.handleSelectAll}
                                          inputProps={{
                                            name: "selectall",
                                            id: "selectall"
                                          }}
                                        >
                                          <MenuItem
                                            disabled
                                            classes={{
                                              root: classes.selectMenuItem
                                            }}
                                          >
                                            == สถานะการส่ง ==
                                          </MenuItem>
                                          <MenuItem
                                            classes={{
                                              root: classes.selectMenuItem,
                                              selected:
                                                classes.selectMenuItemSelected
                                            }}
                                            value="all"
                                          >
                                            ทั้งหมด
                                          </MenuItem>
                                          <MenuItem
                                            classes={{
                                              root: classes.selectMenuItem,
                                              selected:
                                                classes.selectMenuItemSelected
                                            }}
                                            value="Y"
                                          >
                                            ส่งแล้ว
                                          </MenuItem>
                                          <MenuItem
                                            classes={{
                                              root: classes.selectMenuItem,
                                              selected:
                                                classes.selectMenuItemSelected
                                            }}
                                            value="N"
                                          >
                                            ยังไม่ส่ง
                                          </MenuItem>
                                        </Select>
                                      </FormControl>
                                    </div>
                                    <div className="col-xs-6 col-sm-6 col-md-4 mb-3 ml-auto">
                                      <FormControl
                                        fullWidth
                                        className={classes.selectFormControl}
                                      >
                                        <InputLabel
                                          style={{
                                            display:
                                              this.state.user.acstatus !== "4"
                                                ? "block"
                                                : "none"
                                          }}
                                          htmlFor="selectsale"
                                          className={classes.selectLabel}
                                        >
                                          เลือกฝ่ายขาย
                                        </InputLabel>
                                        <Select
                                          style={{
                                            display:
                                              this.state.user.acstatus !== "4"
                                                ? "block"
                                                : "none"
                                          }}
                                          MenuProps={{
                                            className: classes.selectMenu
                                          }}
                                          classes={{
                                            select: classes.select
                                          }}
                                          value={this.state.selectsale}
                                          onChange={this.handleSelectSale_1_3}
                                          inputProps={{
                                            name: "selectsale",
                                            id: "selectsale"
                                          }}
                                        >
                                          <MenuItem key={-1} value={"all"}>
                                            {"ทั้งหมด"}
                                          </MenuItem>
                                          <MenuItem key={-2} value={"none"}>
                                            {"- ไม่มีฝ่ายขาย -"}
                                          </MenuItem>
                                          {this.state.sales}
                                        </Select>
                                      </FormControl>
                                    </div>
                                  </div>
                                  <div className="mt-4">
                                    <MaterialTable
                                      onRowClick={(e, d) =>
                                        this.showContactModal(d)
                                      }
                                      columns={[
                                        {
                                          title: "สถานะ",
                                          field: "status",
                                          defaultSort: "desc",
                                          cellStyle: { width: "1px" }
                                        },
                                        {
                                          title: "ชื่อบริษัท",
                                          field: "company_thname"
                                        },
                                        {
                                          title: "ชื่อลูกค้า",
                                          field: "contact_name"
                                        },
                                        {
                                          title: "เบอร์ติดต่อ",
                                          field: "contact_no"
                                        },
                                        {
                                          title: "อีเมล์",
                                          field: "contact_email"
                                        },
                                        {
                                          title: "ชื่อ Call Center",
                                          field: "call_center_name"
                                        },
                                        {
                                          title: "ชื่อฝ่ายขาย",
                                          field: "sale_name"
                                        }
                                        // {
                                        //   title: "ชื่อฝ่ายขาย",
                                        //   render: rowdata => {
                                        //     return (
                                        //       <div>
                                        //         {/* {rowdata.acfirstname === null
                                        //           ? "-ไม่มีฝ่ายขาย-"
                                        //           : rowdata.acfirstname +
                                        //             " " +
                                        //             rowdata.aclastname} */}
                                        //              {rowdata.sale_name}
                                        //       </div>
                                        //     );
                                        //   }
                                        // }
                                      ]}
                                      data={this.state.data1_3}
                                      title="สถานะ 1.3 - ส่งข้อมูล"
                                    />
                                  </div>
                                </div>
                              )
                            },
                            {
                              tabName: "สถานะ 1.4",
                              tabContent: (
                                <div className="mt-4">
                                  <h4>
                                    จำนวนลูกค้าทั้งหมด{" "}
                                    {this.state.data1_4.length} ราย
                                  </h4>
                                  <div className="row ml-auto mr-auto justify-content-end">
                                    <div className="col-xs-12 col-sm-6 col-md-4 mb-3">
                                      <FormControl
                                        fullWidth
                                        className={classes.selectFormControl}
                                      >
                                        <InputLabel
                                          style={{
                                            display:
                                              this.state.user.acstatus !== "4"
                                                ? "block"
                                                : "none"
                                          }}
                                          htmlFor="selectsale"
                                          className={classes.selectLabel}
                                        >
                                          เลือกฝ่ายขาย
                                        </InputLabel>
                                        <Select
                                          style={{
                                            display:
                                              this.state.user.acstatus !== "4"
                                                ? "block"
                                                : "none"
                                          }}
                                          MenuProps={{
                                            className: classes.selectMenu
                                          }}
                                          classes={{
                                            select: classes.select
                                          }}
                                          value={this.state.selectsale}
                                          onChange={this.handleSelectSale}
                                          inputProps={{
                                            name: "selectsale",
                                            id: "selectsale"
                                          }}
                                        >
                                          <MenuItem key={-1} value={"all"}>
                                            {"ทั้งหมด"}
                                          </MenuItem>
                                          <MenuItem key={-2} value={"none"}>
                                            {"- ไม่มีฝ่ายขาย -"}
                                          </MenuItem>
                                          {this.state.sales}
                                        </Select>
                                      </FormControl>
                                    </div>
                                  </div>
                                  <div className="mt-4">
                                    <MaterialTable
                                      onRowClick={(e, d) =>
                                        this.showContactModal(d)
                                      }
                                      columns={[
                                        {
                                          title: "สถานะ",
                                          field: "status",
                                          defaultSort: "desc",
                                          cellStyle: { width: "1px" }
                                        },
                                        {
                                          title: "ชื่อบริษัท",
                                          field: "company_thname"
                                        },
                                        {
                                          title: "ชื่อลูกค้า",
                                          field: "contact_name"
                                        },
                                        {
                                          title: "เบอร์ติดต่อ",
                                          field: "contact_no"
                                        },
                                        {
                                          title: "อีเมล์",
                                          field: "contact_email"
                                        },
                                        {
                                          title: "ชื่อ Call Center",
                                          field: "call_center_name"
                                        },
                                        {
                                          title: "ชื่อฝ่ายขาย",
                                          field: "sale_name"
                                        }
                                        // {
                                        //   title: "ชื่อฝ่ายขาย",
                                        //   render: rowdata => {
                                        //     return (
                                        //       <div>
                                        //         {/* {rowdata.acfirstname === null
                                        //           ? "-ไม่มีฝ่ายขาย-"
                                        //           : rowdata.acfirstname +
                                        //             " " +
                                        //             rowdata.aclastname} */}
                                        //              {rowdata.sale_name}
                                        //       </div>
                                        //     );
                                        //   }
                                        // }
                                      ]}
                                      data={this.state.data1_4}
                                      title="สถานะ 1.4 - ลูกค้าให้เข้าพบ"
                                    />
                                  </div>
                                </div>
                              )
                            }
                          ]}
                        />
                      </GridItem>
                    </GridContainer>
                  )
                },
                {
                  tabName: "สถานะ 2",
                  tabIcon: TransferWithinAStation,
                  tabContent: (
                    <div className="mt-4">
                      <h4>จำนวนลูกค้าทั้งหมด {this.state.data2.length} ราย</h4>
                      <div className="row ml-auto mr-auto justify-content-end">
                        <div className="col-xs-12 col-sm-6 col-md-4 mb-3">
                          <FormControl
                            fullWidth
                            className={classes.selectFormControl}
                          >
                            <InputLabel
                              style={{
                                display:
                                  this.state.user.acstatus !== "4"
                                    ? "block"
                                    : "none"
                              }}
                              htmlFor="selectsale"
                              className={classes.selectLabel}
                            >
                              เลือกฝ่ายขาย
                            </InputLabel>
                            <Select
                              style={{
                                display:
                                  this.state.user.acstatus !== "4"
                                    ? "block"
                                    : "none"
                              }}
                              MenuProps={{
                                className: classes.selectMenu
                              }}
                              classes={{
                                select: classes.select
                              }}
                              value={this.state.selectsale}
                              onChange={this.handleSelectSale}
                              inputProps={{
                                name: "selectsale",
                                id: "selectsale"
                              }}
                            >
                              <MenuItem key={-1} value={"all"}>
                                {"ทั้งหมด"}
                              </MenuItem>
                              <MenuItem key={-2} value={"none"}>
                                {"- ไม่มีฝ่ายขาย -"}
                              </MenuItem>
                              {this.state.sales}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                      <div className="mt-4">
                        <MaterialTable
                          onRowClick={(e, d) => this.showContactModal(d)}
                          columns={[
                            {
                              title: "สถานะ",
                              field: "status",
                              defaultSort: "desc",
                              cellStyle: { width: "1px" }
                            },
                            { title: "ชื่อบริษัท", field: "company_thname" },
                            { title: "ชื่อลูกค้า", field: "contact_name" },
                            { title: "เบอร์ติดต่อ", field: "contact_no" },
                            { title: "อีเมล์", field: "contact_email" },
                            {
                              title: "ชื่อ Call Center",
                              field: "call_center_name"
                            },
                            {
                              title: "ชื่อฝ่ายขาย",
                              field: "sale_name"
                            }
                            // {
                            //   title: "ชื่อฝ่ายขาย",
                            //   render: rowdata => {
                            //     return (
                            //       <div>
                            //         {/* {rowdata.acfirstname === null
                            //           ? "-ไม่มีฝ่ายขาย-"
                            //           : rowdata.acfirstname +
                            //             " " +
                            //             rowdata.aclastname} */}
                            //              {rowdata.sale_name}
                            //       </div>
                            //     );
                            //   }
                            // }
                          ]}
                          data={this.state.data2}
                          title="สถานะ 2 - เข้าพบลูกค้าแล้ว"
                        />
                      </div>
                    </div>
                  )
                },
                {
                  tabName: "สถานะ 3",
                  tabIcon: MonetizationOn,
                  tabContent: (
                    <div className="mt-4">
                      <h4>จำนวนลูกค้าทั้งหมด {this.state.data3.length} ราย</h4>
                      <div className="row ml-auto mr-auto justify-content-end">
                        <div className="col-xs-12 col-sm-6 col-md-4 mb-3">
                          <FormControl
                            fullWidth
                            className={classes.selectFormControl}
                          >
                            <InputLabel
                              style={{
                                display:
                                  this.state.user.acstatus !== "4"
                                    ? "block"
                                    : "none"
                              }}
                              htmlFor="selectsale"
                              className={classes.selectLabel}
                            >
                              เลือกฝ่ายขาย
                            </InputLabel>
                            <Select
                              style={{
                                display:
                                  this.state.user.acstatus !== "4"
                                    ? "block"
                                    : "none"
                              }}
                              MenuProps={{
                                className: classes.selectMenu
                              }}
                              classes={{
                                select: classes.select
                              }}
                              value={this.state.selectsale}
                              onChange={this.handleSelectSale}
                              inputProps={{
                                name: "selectsale",
                                id: "selectsale"
                              }}
                            >
                              <MenuItem key={-1} value={"all"}>
                                {"ทั้งหมด"}
                              </MenuItem>
                              <MenuItem key={-2} value={"none"}>
                                {"- ไม่มีฝ่ายขาย -"}
                              </MenuItem>
                              {this.state.sales}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                      <div className="mt-4">
                        <MaterialTable
                          onRowClick={(e, d) => this.showContactModal(d)}
                          columns={[
                            {
                              title: "สถานะ",
                              field: "status",
                              defaultSort: "desc",
                              cellStyle: { width: "1px" }
                            },
                            { title: "ชื่อบริษัท", field: "company_thname" },
                            { title: "ชื่อลูกค้า", field: "contact_name" },
                            { title: "เบอร์ติดต่อ", field: "contact_no" },
                            { title: "อีเมล์", field: "contact_email" },
                            {
                              title: "ชื่อ Call Center",
                              field: "call_center_name"
                            },
                            {
                              title: "ชื่อฝ่ายขาย",
                              field: "sale_name"
                            }
                            // {
                            //   title: "ชื่อฝ่ายขาย",
                            //   render: rowdata => {
                            //     return (
                            //       <div>
                            //         {/* {rowdata.acfirstname === null
                            //           ? "-ไม่มีฝ่ายขาย-"
                            //           : rowdata.acfirstname +
                            //             " " +
                            //             rowdata.aclastname} */}
                            //              {rowdata.sale_name}
                            //       </div>
                            //     );
                            //   }
                            // }
                          ]}
                          data={this.state.data3}
                          title="สถานะ 3 - เสนอราคา"
                        />
                      </div>
                    </div>
                  )
                },
                {
                  tabName: "สถานะ 4",
                  tabIcon: ShoppingCart,
                  tabContent: (
                    <div className="mt-4">
                      <h4>จำนวนลูกค้าทั้งหมด {this.state.data4.length} ราย</h4>
                      <div className="row ml-auto mr-auto justify-content-end">
                        <div className="col-xs-12 col-sm-6 col-md-4 mb-3">
                          <FormControl
                            fullWidth
                            className={classes.selectFormControl}
                          >
                            <InputLabel
                              style={{
                                display:
                                  this.state.user.acstatus !== "4"
                                    ? "block"
                                    : "none"
                              }}
                              htmlFor="selectsale"
                              className={classes.selectLabel}
                            >
                              เลือกฝ่ายขาย
                            </InputLabel>
                            <Select
                              style={{
                                display:
                                  this.state.user.acstatus !== "4"
                                    ? "block"
                                    : "none"
                              }}
                              MenuProps={{
                                className: classes.selectMenu
                              }}
                              classes={{
                                select: classes.select
                              }}
                              value={this.state.selectsale}
                              onChange={this.handleSelectSale}
                              inputProps={{
                                name: "selectsale",
                                id: "selectsale"
                              }}
                            >
                              <MenuItem key={-1} value={"all"}>
                                {"ทั้งหมด"}
                              </MenuItem>
                              <MenuItem key={-2} value={"none"}>
                                {"- ไม่มีฝ่ายขาย -"}
                              </MenuItem>
                              {this.state.sales}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                      <div className="mt-4">
                        <MaterialTable
                          onRowClick={(e, d) => this.showContactModal(d)}
                          columns={[
                            {
                              title: "สถานะ",
                              field: "status",
                              defaultSort: "desc",
                              cellStyle: { width: "1px" }
                            },
                            { title: "ชื่อบริษัท", field: "company_thname" },
                            { title: "ชื่อลูกค้า", field: "contact_name" },
                            { title: "เบอร์ติดต่อ", field: "contact_no" },
                            { title: "อีเมล์", field: "contact_email" },
                            {
                              title: "ชื่อ Call Center",
                              field: "call_center_name"
                            },
                            {
                              title: "ชื่อฝ่ายขาย",
                              field: "sale_name"
                            }
                            // {
                            //   title: "ชื่อฝ่ายขาย",
                            //   render: rowdata => {
                            //     return (
                            //       <div>
                            //         {/* {rowdata.acfirstname === null
                            //           ? "-ไม่มีฝ่ายขาย-"
                            //           : rowdata.acfirstname +
                            //             " " +
                            //             rowdata.aclastname} */}
                            //              {rowdata.sale_name}
                            //       </div>
                            //     );
                            //   }
                            // }
                          ]}
                          data={this.state.data4}
                          title="สถานะ 4 - เกิดการสั่งซื้อ"
                        />
                      </div>
                    </div>
                  )
                },
                {
                  tabName: "สถานะ 5",
                  tabIcon: Cached,
                  tabContent: (
                    <div className="mt-4">
                      <h4>จำนวนลูกค้าทั้งหมด {this.state.data5.length} ราย</h4>
                      <div className="row ml-auto mr-auto justify-content-end">
                        <div className="col-xs-12 col-sm-6 col-md-4 mb-3">
                          <FormControl
                            fullWidth
                            className={classes.selectFormControl}
                          >
                            <InputLabel
                              style={{
                                display:
                                  this.state.user.acstatus !== "4"
                                    ? "block"
                                    : "none"
                              }}
                              htmlFor="selectsale"
                              className={classes.selectLabel}
                            >
                              เลือกฝ่ายขาย
                            </InputLabel>
                            <Select
                              style={{
                                display:
                                  this.state.user.acstatus !== "4"
                                    ? "block"
                                    : "none"
                              }}
                              MenuProps={{
                                className: classes.selectMenu
                              }}
                              classes={{
                                select: classes.select
                              }}
                              value={this.state.selectsale}
                              onChange={this.handleSelectSale}
                              inputProps={{
                                name: "selectsale",
                                id: "selectsale"
                              }}
                            >
                              <MenuItem key={-1} value={"all"}>
                                {"ทั้งหมด"}
                              </MenuItem>
                              <MenuItem key={-2} value={"none"}>
                                {"- ไม่มีฝ่ายขาย -"}
                              </MenuItem>
                              {this.state.sales}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                      <div className="mt-4">
                        <MaterialTable
                          onRowClick={(e, d) => this.showContactModal(d)}
                          columns={[
                            {
                              title: "สถานะ",
                              field: "status",
                              defaultSort: "desc",
                              cellStyle: { width: "1px" }
                            },
                            { title: "ชื่อบริษัท", field: "company_thname" },
                            { title: "ชื่อลูกค้า", field: "contact_name" },
                            { title: "เบอร์ติดต่อ", field: "contact_no" },
                            { title: "อีเมล์", field: "contact_email" },
                            {
                              title: "ชื่อ Call Center",
                              field: "call_center_name"
                            },
                            {
                              title: "ชื่อฝ่ายขาย",
                              field: "sale_name"
                            }
                            // {
                            //   title: "ชื่อฝ่ายขาย",
                            //   render: rowdata => {
                            //     return (
                            //       <div>
                            //         {/* {rowdata.acfirstname === null
                            //           ? "-ไม่มีฝ่ายขาย-"
                            //           : rowdata.acfirstname +
                            //             " " +
                            //             rowdata.aclastname} */}
                            //              {rowdata.sale_name}
                            //       </div>
                            //     );
                            //   }
                            // }
                          ]}
                          data={this.state.data5}
                          title="สถานะ 5 - ซื้อซ้ำ"
                        />
                      </div>
                    </div>
                  )
                }
              ]}
            />
          </GridItem>
        </GridContainer>

        <Modal className="modal-search" isOpen={this.state.modal}>
          <ModalHeader toggle={this.toggledatatable}>ข้อมูลลูกค้า</ModalHeader>
          <ModalBody>
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-6">
                <Form>
                  <FormGroup
                    style={{
                      color: "#8A8A8A",
                      display:
                        this.state.tmp_contact.status == "1.3"
                          ? "block"
                          : "none",
                      margin: 10
                    }}
                    check
                  >
                    <Label check>
                      <b>สถานะการส่งอีเมล์ :</b>
                      <Input
                        checked={
                          this.state.tmp_contact.send_info === "Y"
                            ? true
                            : false
                        }
                        onChange={this.changeSendInfo}
                        style={{ marginLeft: 10 }}
                        type="checkbox"
                        id="checkbox2"
                      />{" "}
                      <Label style={{ marginLeft: 20, marginTop: 2 }}>
                        <b>ส่งข้อมูล</b>
                      </Label>
                    </Label>
                  </FormGroup>

                  <FormGroup>
                    <Button
                      color="success"
                      style={{
                        display:
                          this.state.tmp_contact.status == "1.3" &&
                          this.state.tmp_contact.acusername !== null &&
                          this.state.tmp_contact.acusername !== ""
                            ? "block"
                            : "none",
                        marginLeft: 15
                      }}
                      onClick={this.toggleReceiveEmail}
                    >
                      <Icon className="pt-1">email</Icon>
                      ส่งอีเมล์ โดย {this.state.tmp_contact.acemail}
                    </Button>
                  </FormGroup>
                </Form>
              </div>
              <div className="col-xs-12 col-sm-6 col-md-6 text-right pr-4">
                <Button color="danger"  onClick={this.toggleDeleteCompany}>
                  <Icon className="pt-1">delete</Icon>
                  ลบข้อมูลบริษัท
                </Button>
              </div>
            </div>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <CustomTabs
                  className="table-responsive"
                  headerColor="info"
                  tabs={[
                    {
                      tabName: "ข้อมูลบริษัท",
                      tabIcon: Home,
                      tabContent: (
                        <div className="mt-4">
                          <Button
                            onClick={() =>
                              this.setState({
                                openEditSec1: true
                              })
                            }
                            color="warning"
                            style={{
                              color: "white",
                              display:
                                this.state.openEditSec1 === false
                                  ? "inline"
                                  : "none"
                            }}
                          >
                            <Icon className="pt-1">edit</Icon> แก้ไข{" "}
                          </Button>{" "}
                          <Button
                            onClick={() => this.updateSecData("1")}
                            color="primary"
                            style={{
                              color: "white",
                              display:
                                this.state.openEditSec1 === true
                                  ? "inline"
                                  : "none"
                            }}
                          >
                            <Icon className="pt-1">save</Icon> บันทึก{" "}
                          </Button>{" "}
                          <Button
                            color="danger"
                            onClick={() =>
                              this.cancelEdit(this.state.tmp_contact.ct_running)
                            }
                            style={{
                              color: "white",
                              display:
                                this.state.openEditSec1 === true
                                  ? "inline"
                                  : "none"
                            }}
                          >
                            <Icon className="pt-1">close</Icon> ยกเลิก{" "}
                          </Button>{" "}
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={6}>
                              <CustomInput
                                labelText="Tax ID: "
                                id="taxid"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  value: this.state.tmp_contact.tax_id,
                                  name: "tax_id",
                                  disabled: !this.state.openEditSec1
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={6}>
                              <CustomInput
                                labelText="cs: "
                                id="companyid"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "account_no",
                                  value: this.state.tmp_contact.account_no,
                                  disabled: !this.state.openEditSec1
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={6}>
                              <CustomInput
                                labelText="ชื่อภาษาไทย: "
                                id="companynameth"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "company_thname",
                                  value: this.state.tmp_contact.company_thname,
                                  disabled: !this.state.openEditSec1
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={6}>
                              <CustomInput
                                labelText="ชื่อภาษาอังกฤษ: "
                                id="companynameen"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "company_enname",
                                  value: this.state.tmp_contact.company_enname,
                                  disabled: !this.state.openEditSec1
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={4}>
                              <CustomInput
                                labelText="กลุ่มของบริษัท (ชื่อภาษาไทย): "
                                id="groupth"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "group_thname",
                                  value: this.state.tmp_contact.group_thname,
                                  disabled: !this.state.openEditSec1
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={4}>
                              <CustomInput
                                labelText="กลุ่มของบริษัท (ชื่อภาษาอังกฤษ): "
                                id="groupen"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "group_enname",
                                  value: this.state.tmp_contact.group_enname,
                                  disabled: !this.state.openEditSec1
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={4}>
                              <CustomInput
                                labelText="Parent: "
                                id="parent"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "parent_account",
                                  value: this.state.tmp_contact.parent_account,
                                  disabled: !this.state.openEditSec1
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={3}>
                              <CustomInput
                                labelText="Address NO: "
                                id="address"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "address_no",
                                  value: this.state.tmp_contact.address_no,
                                  disabled: !this.state.openEditSec1
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={3}>
                              <CustomInput
                                labelText="หมู่: "
                                formControlProps={{
                                  fullWidth: !this.state.openEditSec1
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "moo",
                                  value: this.state.tmp_contact.moo,
                                  disabled: !this.state.openEditSec1
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={3}>
                              <CustomInput
                                labelText="ซอย: "
                                id="soy"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "soi",
                                  value: this.state.tmp_contact.soi,
                                  disabled: !this.state.openEditSec1
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={3}>
                              <CustomInput
                                labelText="หมู่บ้าน: "
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "vilage",
                                  defaultValue: this.state.tmp_contact.vilage,
                                  disabled: !this.state.openEditSec1
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={3}>
                              <CustomInput
                                labelText="ถนน: "
                                id="street"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "road",
                                  value: this.state.tmp_contact.road,
                                  disabled: !this.state.openEditSec1
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={3}>
                              <CustomInput
                                labelText="แขวง/ตำบล: "
                                id="subdistrict"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "subdistrict",
                                  value: this.state.tmp_contact.subdistrict,
                                  disabled: !this.state.openEditSec1
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={3}>
                              <CustomInput
                                labelText="เขต/อำเภอ: "
                                id="district"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "district",
                                  value: this.state.tmp_contact.district,
                                  disabled: !this.state.openEditSec1
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={3}>
                              <CustomInput
                                labelText="จังหวัด: "
                                id="province"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "province",
                                  value: this.state.tmp_contact.province,
                                  disabled: !this.state.openEditSec1
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={4}>
                              <CustomInput
                                labelText="ไปรษณีย์: "
                                id="Postalcode"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "zipcode",
                                  value: this.state.tmp_contact.zipcode,
                                  disabled: !this.state.openEditSec1
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                        </div>
                      )
                    },
                    {
                      tabName: "ข้อมูลผู้ติดต่อ",
                      tabIcon: AccountBox,
                      tabContent: (
                        <div className="mt-4">
                          <Button
                            onClick={() =>
                              this.setState({
                                openEditSec2: true
                              })
                            }
                            color="warning"
                            style={{
                              color: "white",
                              display:
                                this.state.openEditSec2 === false
                                  ? "inline"
                                  : "none"
                            }}
                          >
                            <Icon className="pt-1">edit</Icon> แก้ไข{" "}
                          </Button>{" "}
                          <Button
                            onClick={() => this.updateSecData("2")}
                            color="primary"
                            style={{
                              color: "white",
                              display:
                                this.state.openEditSec2 === true
                                  ? "inline"
                                  : "none"
                            }}
                          >
                            <Icon className="pt-1">save</Icon> บันทึก{" "}
                          </Button>{" "}
                          <Button
                            color="danger"
                            onClick={() =>
                              this.cancelEdit(this.state.tmp_contact.ct_running)
                            }
                            style={{
                              color: "white",
                              display:
                                this.state.openEditSec2 === true
                                  ? "inline"
                                  : "none"
                            }}
                          >
                            <Icon className="pt-1">close</Icon> ยกเลิก{" "}
                          </Button>{" "}
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={6}>
                              <CustomInput
                                labelText="Contact Name: "
                                id="contactname"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "contact_name",
                                  value: this.state.tmp_contact.contact_name,
                                  disabled: !this.state.openEditSec2
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={6}>
                              <CustomInput
                                labelText="Phone No.: "
                                id="phone"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "contact_no",
                                  value: this.state.tmp_contact.contact_no,
                                  disabled: !this.state.openEditSec2
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={6}>
                              <CustomInput
                                labelText="Email: "
                                id="email"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "contact_email",
                                  value: this.state.tmp_contact.contact_email,
                                  disabled: !this.state.openEditSec2
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={6}>
                              <CustomInput
                                labelText="Type: "
                                id="type"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "type",
                                  value: this.state.tmp_contact.type,
                                  disabled: !this.state.openEditSec2
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={8}>
                              <CustomInput
                                labelText="Customer Product: "
                                id="customer"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "customer_product",
                                  value: this.state.tmp_contact
                                    .customer_product,
                                  disabled: !this.state.openEditSec2
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={6}>
                              <CustomInput
                                labelText="Contact Name 2: "
                                id="contactname2"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "contact_name_2",
                                  value: this.state.tmp_contact.contact_name_2,
                                  disabled: !this.state.openEditSec2
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={6}>
                              <CustomInput
                                labelText="Phone No. 2: "
                                id="phone2"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "contact_no_2",
                                  value: this.state.tmp_contact.contact_no_2,
                                  disabled: !this.state.openEditSec2
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={6}>
                              <CustomInput
                                labelText="Email 2: "
                                id="email2"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "contact_email_2",
                                  value: this.state.tmp_contact.contact_email_2,
                                  disabled: !this.state.openEditSec2
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={6}>
                              <CustomInput
                                labelText="Grade: "
                                id="grade"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "grade",
                                  value: this.state.tmp_contact.grade,
                                  disabled: !this.state.openEditSec2
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={8}>
                              <CustomInput
                                labelText="Customer Product 2: "
                                id="customer2"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "customer_product_2",
                                  value: this.state.tmp_contact
                                    .customer_product_2,
                                  disabled: !this.state.openEditSec2
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                        </div>
                      )
                    },
                    {
                      tabName: "ข้อมูลฝ่ายขาย",
                      tabIcon: Person,
                      tabContent: (
                        <div className="mt-4">
                          <Button
                            onClick={() =>
                              this.setState({
                                openEditSec3: true
                              })
                            }
                            color="warning"
                            style={{
                              color: "white",
                              display:
                                this.state.openEditSec3 === false
                                  ? "inline"
                                  : "none"
                            }}
                          >
                            <Icon className="pt-1">edit</Icon> แก้ไข{" "}
                          </Button>{" "}
                          <Button
                            onClick={() => this.updateSecData("3")}
                            color="primary"
                            style={{
                              color: "white",
                              display:
                                this.state.openEditSec3 === true
                                  ? "inline"
                                  : "none"
                            }}
                          >
                            <Icon className="pt-1">save</Icon> บันทึก{" "}
                          </Button>{" "}
                          <Button
                            color="danger"
                            onClick={() =>
                              this.cancelEdit(this.state.tmp_contact.ct_running)
                            }
                            style={{
                              color: "white",
                              display:
                                this.state.openEditSec3 === true
                                  ? "inline"
                                  : "none"
                            }}
                          >
                            <Icon className="pt-1">close</Icon> ยกเลิก{" "}
                          </Button>{" "}
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={6}>
                              <div
                                style={{
                                  paddingTop: 45,
                                  display:
                                   ( this.state.openEditSec3 === true &&
                                    this.state.user.acstatus !== "1" &&
                                   ( this.state.user.acstatus !== "4" ||
                                    (this.state.tmp_contact.sales_id === null ||
                                      this.state.tmp_contact.sales_id === "")))

                                      ? "block"
                                      : "none"
                                }}
                              >
                                <Select
                                  style={{
                                    width: "100%"
                                  }}
                                  MenuProps={{
                                    className: classes.selectMenu
                                  }}
                                  classes={{
                                    select: classes.select
                                  }}
                                  value={this.state.tmp_contact.sales_id}
                                  onChange={this.handleSelectSaleSec3}
                                  inputProps={{
                                    name: "selectsale",
                                    id: "selectsale"
                                  }}
                                >
                                  <MenuItem key={-1} value={""}>
                                    {"ไม่มี"}
                                  </MenuItem>
                                  {this.state.user.acstatus !== "4" ? 
                                  this.state.sales : 
                                   <MenuItem key={-1} value={this.state.user.acusername}>
                                    {this.state.user.acfirstname + " "+this.state.user.aclastname}
                                  </MenuItem>}
                                </Select>
                              </div>
                       
                              <CustomInput
                                labelText="Sale Name: "
                                id="salename"
                                style={{
                                  display:
                                   ( this.state.openEditSec3 === false ||
                                    ( this.state.user.acstatus === "4" &&
                                    (this.state.tmp_contact.sales_id !== null &&
                                      this.state.tmp_contact.sales_id !== "")))

                                      ? "inline"
                                      : "none"
                                }}
                                formControlProps={{
                                  fullWidth: true
                                }}
                                labelProps={{
                                  style: {
                                    display:
                                     ( this.state.openEditSec3 === false ||
                                      ( this.state.user.acstatus === "4" &&
                                      (this.state.tmp_contact.sales_id !== null &&
                                        this.state.tmp_contact.sales_id !== "")))
                                        ? "inline"
                                        : "none"
                                  }
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "sale_name",
                                  value:
                                    this.state.tmp_contact.sale_name === null
                                      ? "-ไม่มีฝ่ายขาย-"
                                      : this.state.tmp_contact.sale_name,

                                  // this.state.tmp_contact.acfirstname === null
                                  //   ? "-ไม่มีฝ่ายขาย-"
                                  //   : this.state.tmp_contact.acfirstname +
                                  //     " " +
                                  //     this.state.tmp_contact.aclastname,
                                  disabled:
                                    !this.state.openEditSec3 ||
                                    this.state.user.acstatus === "4",
                                  style: {
                                    display:
                                    ( this.state.openEditSec3 === false ||
                                      ( this.state.user.acstatus === "4" &&
                                      (this.state.tmp_contact.sales_id !== null &&
                                        this.state.tmp_contact.sales_id !== "")))
                                        ? "inline"
                                        : "none"
                                  }
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={6}>
                              <CustomInput
                                labelText="Phone No. (Sale): "
                                id="phonesale"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "sale_phone",
                                  value: this.state.tmp_contact.actelephone,
                                  disabled: true
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={6}>
                              <CustomInput
                                labelText="Email (Sale): "
                                id="emailsale"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "sale_email",
                                  value: this.state.tmp_contact.acemail,
                                  disabled: true
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={6}>
                              <div
                                style={{
                                  display:
                                    this.state.openEditSec3 === true
                                      ? "inline"
                                      : "none"
                                }}
                              >
                                <Select
                                  style={{
                                    width: "100%",
                                    marginTop: 40
                                  }}
                                  MenuProps={{
                                    className: classes.selectMenu
                                  }}
                                  classes={{
                                    select: classes.select
                                  }}
                                  value={this.state.selectcallcenter}
                                  onChange={this.handleSelectCallCenterSec3}
                                  inputProps={{
                                    name: "selectcallcenter",
                                    id: "selectcallcenter"
                                  }}
                                >
                                  <MenuItem key={-1} value={""}>
                                    {"ไม่มี"}
                                  </MenuItem>
                                  {this.state.callcenter}
                                </Select>
                              </div>
                              <CustomInput
                                style={{
                                  display:
                                    this.state.openEditSec3 === false
                                      ? "inline"
                                      : "none"
                                }}
                                labelProps={{
                                  style: {
                                    display:
                                      this.state.openEditSec3 === false
                                        ? "inline"
                                        : "none"
                                  }
                                }}
                                labelText="Call Center Name: "
                                id="callcentername"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "call_center_name",
                                  value: this.state.tmp_contact
                                    .call_center_name,
                                  disabled: !this.state.openEditSec3,
                                  style: {
                                    display:
                                      this.state.openEditSec3 === false
                                        ? "inline"
                                        : "none"
                                  }
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                        </div>
                      )
                    },
                    {
                      tabName: "ข้อมูลทางบัญชี",
                      tabIcon: Assessment,
                      tabContent: (
                        <div className="mt-4">
                          <Button
                            onClick={() =>
                              this.setState({
                                openEditSec4: true
                              })
                            }
                            color="warning"
                            style={{
                              color: "white",
                              display:
                                this.state.openEditSec4 === false
                                  ? "inline"
                                  : "none"
                            }}
                          >
                            <Icon className="pt-1">edit</Icon> แก้ไข
                          </Button>{" "}
                          <Button
                            onClick={() => this.updateSecData("4")}
                            color="primary"
                            style={{
                              color: "white",
                              display:
                                this.state.openEditSec4 === true
                                  ? "inline"
                                  : "none"
                            }}
                          >
                            <Icon className="pt-1">save</Icon> บันทึก{" "}
                          </Button>{" "}
                          <Button
                            color="danger"
                            onClick={() =>
                              this.cancelEdit(this.state.tmp_contact.ct_running)
                            }
                            style={{
                              color: "white",
                              display:
                                this.state.openEditSec4 === true
                                  ? "inline"
                                  : "none"
                            }}
                          >
                            <Icon className="pt-1">close</Icon> ยกเลิก{" "}
                          </Button>{" "}
                          <GridContainer>
                          <GridItem xs={12} sm={12} md={2}>
                              <CustomInput
                                labelText="Financial Code: "
                                id="finangrade"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "financial_code",
                                  value: this.state.tmp_contact.financial_code,
                                  disabled: !this.state.openEditSec4
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={2}>
                              <CustomInput
                                labelText="Financial Grade: "
                                id="finangrade"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "financial_grade",
                                  value: this.state.tmp_contact.financial_grade,
                                  disabled: !this.state.openEditSec4
                                }}
                              />
                            </GridItem>
                           
                            <GridItem xs={12} sm={12} md={4}>
                              <CustomInput
                                labelText="Billing Name: "
                                id="billname"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "billing_name",
                                  value: this.state.tmp_contact.billing_name,
                                  disabled: !this.state.openEditSec4
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={4}>
                              <CustomInput
                                labelText="Billing Place: "
                                id="billplace"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "billing_place",
                                  value: this.state.tmp_contact.billing_place,
                                  disabled: !this.state.openEditSec4
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={4}>
                              <CustomInput
                                labelText="Billing Create Date: "
                                id="createdate"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "bill_create_date",
                                  value: this.state.tmp_contact
                                    .bill_create_date,
                                  disabled: !this.state.openEditSec4,
                                  type:
                                    this.state.openEditSec4 === true
                                      ? "date"
                                      : "text"
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={4}>
                              <CustomInput
                                labelText="Cheque Receive Date: "
                                id="receivedate"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  value: this.state.tmp_contact
                                    .cheque_receive_date,
                                  name: "cheque_receive_date",
                                  disabled: !this.state.openEditSec4,
                                  type:
                                    this.state.openEditSec4 === true
                                      ? "date"
                                      : "text"
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={4}>
                              <CustomInput
                                labelText="Finance Officer Name: "
                                id="officename"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  value: this.state.tmp_contact
                                    .financial_contact_name,
                                  name: "financial_contact_name",
                                  disabled: !this.state.openEditSec4
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={4}>
                              <CustomInput
                                labelText="Phone No.: "
                                id="phonenoaccout"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "telephone1",
                                  value: this.state.tmp_contact.telephone1,
                                  disabled: !this.state.openEditSec4
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={4}>
                              <CustomInput
                                labelText="Email: "
                                id="emailaccount"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  onChange: this.handleChangeInputSec,
                                  name: "contact_email",
                                  value: this.state.tmp_contact.contact_email,
                                  disabled: !this.state.openEditSec4
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                        </div>
                      )
                    },
                    {
                      tabName: "โน๊ต",
                      tabIcon: EventNote,
                      tabContent: (
                        <div className="mt-4">
                          <GridContainer>
                            <GridItem xs={6} sm={3} md={2}>
                              <Button
                                onClick={this.toggleAddnote}
                                color="info"
                                style={{ color: "white" }}
                              >
                                <Icon className="pt-1">note_add</Icon> เพิ่มโน๊ต{" "}
                              </Button>{" "}
                            </GridItem>
                            <GridItem xs={6} sm={3} md={3}>
                              <Button
                                color="warning"
                                style={{ color: "white" }}
                                onClick={this.toggleNotify}
                              >
                                <Icon className="pt-1">
                                  notifications_active
                                </Icon>{" "}
                                แจ้งเตือน{" "}
                              </Button>{" "}
                            </GridItem>
                          </GridContainer>
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                              <div className="mt-3">
                                <MaterialTable
                                  title="ประวัติการเปลี่ยนแปลง"
                                  columns={[
                                    {
                                      title: "สถานะ",
                                      field: "status",
                                      cellStyle: { width: "1px" }
                                    },
                                    {
                                      title: "กรอกโดย",
                                      render: rowdata =>{
                                        if(rowdata.id!==-2){
                                          return rowdata.acfirstname+" "+rowdata.aclastname
                                        }
                                        else{
                                          return rowdata.create_by
                                        }
                                       
                                      }
                                    },
                                    {
                                      title: "รายละเอียด",
                                      render: rowdata => {
                                        return (
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html: rowdata.text
                                            }}
                                          />
                                        );
                                      }
                                    },
                                    {
                                      title: "เอกสาร",
                                      render: rowdata => {
                                        return (
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html: rowdata.doc
                                            }}
                                          />
                                        );
                                      }
                                    },
                                    {
                                      title: "วันที่",
                                      field: "create_date",
                                      defaultSort: "desc"
                                    }
                                  ]}
                                  data={this.state.notes}
                                />
                              </div>
                            </GridItem>
                          </GridContainer>
                        </div>
                      )
                    }
                  ]}
                />
              </GridItem>
            </GridContainer>
          </ModalBody>
          <ModalFooter>
            <FormControl
              style={{ width: "200px" }}
              className={classes.selectFormControl}
            >
              <InputLabel
                htmlFor="simple-select"
                className={classes.selectLabel}
              >
                เปลี่ยนสถานะ
              </InputLabel>
              <Select
                MenuProps={{
                  className: classes.selectMenu
                }}
                classes={{
                  select: classes.select
                }}
                value={this.state.status}
                onChange={this.handleChangeStatus}
                onOpen={this.handleChangeStatus}
                inputProps={{
                  name: "status",
                  id: "status"
                }}
              >
                <MenuItem
                  classes={{
                    root: classes.selectMenuItem,
                    selected: classes.selectMenuItemSelected
                  }}
                  value="0"
                  onClick={this.toggleChangeStatus}
                >
                  0 - ยังไม่มีการติดต่อ
                </MenuItem>
                <MenuItem
                  classes={{
                    root: classes.selectMenuItem,
                    selected: classes.selectMenuItemSelected
                  }}
                  value="1.1"
                  onClick={this.toggleChangeStatus}
                >
                  1.1 - ยังไม่สนใจ
                </MenuItem>
                <MenuItem
                  classes={{
                    root: classes.selectMenuItem,
                    selected: classes.selectMenuItemSelected
                  }}
                  value="1.2"
                  onClick={this.toggleChangeStatus}
                >
                  1.2 - Call Center ติดตาม
                </MenuItem>
                <MenuItem
                  classes={{
                    root: classes.selectMenuItem,
                    selected: classes.selectMenuItemSelected
                  }}
                  value="1.3"
                  onClick={this.toggleChangeStatus}
                >
                  1.3 - ส่งข้อมูล
                </MenuItem>
                <MenuItem
                  classes={{
                    root: classes.selectMenuItem,
                    selected: classes.selectMenuItemSelected
                  }}
                  value="1.4"
                  onClick={this.toggleChangeStatus}
                >
                  1.4 - ลูกค้าให้เข้าพบ
                </MenuItem>
                <MenuItem
                  classes={{
                    root: classes.selectMenuItem,
                    selected: classes.selectMenuItemSelected
                  }}
                  value="2"
                  onClick={this.toggleChangeStatus}
                >
                  2 - เข้าพบลูกค้าแล้ว
                </MenuItem>
                <MenuItem
                  classes={{
                    root: classes.selectMenuItem,
                    selected: classes.selectMenuItemSelected
                  }}
                  value="3"
                  onClick={this.toggleChangeStatus}
                >
                  3 - เสนอราคา
                </MenuItem>
                <MenuItem
                  classes={{
                    root: classes.selectMenuItem,
                    selected: classes.selectMenuItemSelected
                  }}
                  value="4"
                  onClick={this.toggleChangeStatus}
                >
                  4 - ลูกค้าซื้อ
                </MenuItem>
                <MenuItem
                  classes={{
                    root: classes.selectMenuItem,
                    selected: classes.selectMenuItemSelected
                  }}
                  value="5"
                  onClick={this.toggleChangeStatus}
                >
                  5 - ข้อมูลซื้อซ้ำ
                </MenuItem>
              </Select>
            </FormControl>
            <Button
              color="secondary"
              style={{ margin: "15px" }}
              onClick={this.toggledatatable}
            >
              ปิด
            </Button>
          </ModalFooter>
        </Modal>

        {/* Modal Upload */}
        <Modal
          className="modal-upload"
          isOpen={this.state.modalUpload}
          toggleUpload={this.toggleUpload}
        >
          <ModalHeader toggle={this.toggleUpload}>
            อัพโหลดไฟล์ Excel
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label for="exampleFile">File</Label> <br />
              <Label for="exampleFile">เลือกไฟล์ (.xlsx, .xls เท่านั้น)</Label>
              <Input
                type="file"
                name="file"
                id="importExcel"
                style={{ border: "2px solid #f5f5f5" }}
              />
              <FormText color="muted">
                ดาวน์โหลดไฟล์เทมเพลต :
                <ExcelFile
                  element={<span style={{ color: "green" }}>Excel</span>}
                >
                  <ExcelSheet
                    dataSet={this.state.dataExcelTemp}
                    name="Organization"
                  />
                </ExcelFile>{" "}
                <br />
                <span style={{ color: "red" }}>
                  *หมายเหตุ: ถ้าไม่ระบุ tax id ระบบจะไม่นำเข้าข้อมูล
                </span>
              </FormText>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              onClick={() => {
                this.toggleUpload();
                this.importExcel();
              }}
            >
              อัพโหลด
            </Button>{" "}
            <Button color="secondary" onClick={this.toggleUpload}>
              ปิด
            </Button>
          </ModalFooter>
        </Modal>

        {/*Modal Export */}
        <Modal
          className="modal-export"
          isOpen={this.state.modalExport}
          toggleExport={this.toggleExport}
        >
          <ModalHeader toggle={this.toggleExport}>
            เลือกรูปแบบรายงาน
          </ModalHeader>
          <ModalBody>
            <Form>
            <FormControl
                              fullWidth
                              className={classes.selectFormControl}
                            >
                              <InputLabel
                                style={{
                                  display:
                                    this.state.user.acstatus !== "4"
                                      ? "block"
                                      : "none"
                                }}
                                htmlFor="simple-select"
                                className={classes.selectLabel}
                              >
                                เลือกฝ่ายขาย
                              </InputLabel>
                              <Select
                                style={{
                                  display:
                                    this.state.user.acstatus !== "4"
                                      ? "block"
                                      : "none"
                                }}
                                MenuProps={{
                                  className: classes.selectMenu
                                }}
                                classes={{
                                  select: classes.select
                                }}
                                value={this.state.selectSaleExport}
                                onChange={this.handleSelectSaleExport}
                                inputProps={{
                                  name: "selectSaleExport",
                                  id: "selectSaleExport"
                                }}
                              >
                                <MenuItem key={-1} value={"all"}>
                                  {"ทั้งหมด"}
                                </MenuItem>
                                <MenuItem key={-2} value={"none"}>
                                  {"- ไม่มีฝ่ายขาย -"}
                                </MenuItem>
                                {this.state.sales}
                              </Select>
                            </FormControl>
                            <div style={{margin:5}} />
              <FormGroup>
                <Label for="exampleDate">เริ่ม</Label>
                <Input
                  type="date"
                  name="dateStart"
                  id="dateStart"
                  onChange={this.handleChangeInputDate}
                  value={this.state.dateStart}
                  placeholder="date placeholder"
                />
              </FormGroup>
              <FormGroup>
                <Label for="exampleDate">ถึง</Label>
                <Input
                  type="date"
                  name="dateEnd"
                  id="dateEnd"
                  onChange={this.handleChangeInputDate}
                  value={this.state.dateEnd}
                  placeholder="date placeholder"
                />
              </FormGroup>
              <FormGroup check>
                <Label check className="font-check">
                  <Input
                    type="checkbox"
                    className="checkbox"
                    onChange={() => this.checkboxExport("all")}
                    checked={this.state.exportAll}
                  />{" "}
                  เลือกทั้งหมด
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check className="font-check">
                  <Input
                    type="checkbox"
                    className="checkbox"
                    onChange={() => this.checkboxExport("export0")}
                    checked={this.state.export0}
                  />{" "}
                  สถานะ 0 - ยังไม่มีการติดต่อ
                </Label>
              </FormGroup>
              {/* <FormGroup check>
                <Label check className="font-check">
                  <Input type="checkbox" className="checkbox"  /> สถานะ 1 -
                  โทรติดต่อลูกค้าแล้ว
                </Label>
              </FormGroup> */}
              <FormGroup check>
                <Label check className="font-check">
                  <Input
                    type="checkbox"
                    onChange={() => this.checkboxExport("export11")}
                    className="checkbox"
                    checked={this.state.export11}
                  />{" "}
                  สถานะ 1.1 - ยังไม่สนใจ
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check className="font-check">
                  <Input
                    type="checkbox"
                    onChange={() => this.checkboxExport("export12")}
                    className="checkbox"
                    checked={this.state.export12}
                  />{" "}
                  สถานะ 1.2 - Call Center ติดตาม
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check className="font-check">
                  <Input
                    type="checkbox"
                    className="checkbox"
                    onChange={() => this.checkboxExport("export13")}
                    checked={this.state.export13}
                  />{" "}
                  สถานะ 1.3 - ส่งข้อมูล
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check className="font-check">
                  <Input
                    type="checkbox"
                    className="checkbox"
                    onChange={() => this.checkboxExport("export14")}
                    checked={this.state.export14}
                  />{" "}
                  สถานะ 1.4 - ลูกค้าให้เข้าพบ
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check className="font-check">
                  <Input
                    type="checkbox"
                    className="checkbox"
                    onChange={() => this.checkboxExport("export2")}
                    checked={this.state.export2}
                  />{" "}
                  สถานะ 2 - เข้าพบลูกค้าแล้ว
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check className="font-check">
                  <Input
                    type="checkbox"
                    className="checkbox"
                    onChange={() => this.checkboxExport("export3")}
                    checked={this.state.export3}
                  />{" "}
                  สถานะ 3 - เสนอราคา
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check className="font-check">
                  <Input
                    type="checkbox"
                    className="checkbox"
                    onChange={() => this.checkboxExport("export4")}
                    checked={this.state.export4}
                  />{" "}
                  สถานะ 4 - เกิดการสั่งซื้อ
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check className="font-check">
                  <Input
                    type="checkbox"
                    className="checkbox"
                    onChange={() => this.checkboxExport("export5")}
                    checked={this.state.export5}
                  />{" "}
                  สถานะ 5 - ซื้อซ้ำ
                </Label>
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <ExcelFile 
            filename={'MKSP_CVM_'+(new Date().getDate().toString().length>1 ? new Date().getDate() : "0"+new Date().getDate().toString())   +((new Date().getMonth()+1).toString().length>1 ?( new Date().getMonth()+1) : "0"+(new Date().getMonth()+1).toString() ) +new Date().getFullYear()}
            element={<Button color="primary">ออกรายงาน</Button>}>
              <ExcelSheet dataSet={this.state.dataExcel} name="Organization" />
            </ExcelFile>{" "}
            <Button color="secondary" onClick={this.toggleExport}>
              ปิด
            </Button>
          </ModalFooter>
        </Modal>

        {/*Modal delete info company */}
        <Modal
          className="modal-export"
          isOpen={this.state.modalDeleteCompany}
          toggle={this.toggleDeleteCompany}
        >
          <ModalHeader toggle={this.toggleDeleteCompany}>
            <Warning style={{ color: "red" }} />
            ลบข้อมูลบริษัท !
          </ModalHeader>
          <ModalBody>
            <h6>คุณต้องการลบข้อมูลบริษัทหรือไม่</h6>
          </ModalBody>
          <ModalFooter>
            <Button
              color="danger"
              onClick={() => {
                this.deleteCompany();
              }}
            >
              ยืนยัน
            </Button>{" "}
            <Button color="secondary" onClick={this.toggleDeleteCompany}>
              ยกเลิก
            </Button>
          </ModalFooter>
        </Modal>

        {/*Modal Change Status */}
        <Modal
          className="modal-export"
          isOpen={this.state.modalChangeStatus}
          toggle={this.toggleChangeStatus}
        >
          <ModalHeader toggle={this.toggleChangeStatus}>
            <Warning style={{ color: "#FFC107" }} />
            เปลี่ยนสถานะ
          </ModalHeader>
          <ModalBody>
            ยืนยันการเปลี่ยนสถานะ
            <div className="row">
              <div
                className="col-xs-12 col-md-6"
                style={{
                  display: this.state.status === "4" ? "block" : "none"
                }}
              >
                <FormGroup>
                  <Label for="order">ใบสั่งซื้อ (.pdf)</Label>
                  <Input type="file" name="order" id="orderFile" />
                </FormGroup>
              </div>
              <div
                className="col-xs-12 col-md-6"
                style={{
                  display: this.state.status === "4" ? "block" : "none"
                }}
              >
                <FormGroup>
                  <Label for="proposal">proposal (.pdf)</Label>
                  <Input type="file" name="proposal" id="proposalFile" />
                </FormGroup>
              </div>
              <div
                style={{
                  display: this.state.status === "2" ? "block" : "none"
                }}
                className="col-xs-12 col-md-6"
              >
                <FormGroup>
                  <Label for="proposal">นามบัตร (.pdf)</Label>
                  <Input type="file" name="proposal" id="cardFile" />
                </FormGroup>
              </div>
              <div
                className="col-xs-12 col-md-6"
                style={{
                  display: this.state.status === "3" ? "block" : "none"
                }}
              >
                <FormGroup>
                  <Label for="proposal">cs</Label>
                  <Input
                    type="text"
                    name="tmp_account_no"
                    // disabled={this.state.cs}
                    value={this.state.tmp_account_no}
                    onChange={this.handleChangeCS}
                  />
                </FormGroup>
              </div>
              <div
                className="col-xs-12 col-md-6"
                style={{
                  display: this.state.status === "3" ? "block" : "none"
                }}
              >
                <FormGroup>
                  <Label for="proposal">ใบเสนอราคา (.pdf)</Label>
                  <Input type="file" name="proposal" id="priceFile" />
                </FormGroup>

              </div>
            </div>
            <div className="row mr-auto ml-auto text-right">
              <Button
                onClick={this.changeStatusOK}
                disabled={this.state.Loading || (( this.state.tmp_account_no.length === 0 ? true : false) && this.state.status === "3")}
                color="success"
                className="text-center"
              >
                <Icon className="pt-1 mr-1">save</Icon>ยืนยัน
              </Button>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button onClick={this.toggleChangeStatus}>ปิด</Button>{" "}
            {/* <Button color="secondary" onClick={this.toggleChangeStatus}>
              ยกเลิก
            </Button> */}
          </ModalFooter>
        </Modal>

        {/*Modal Notify */}
        <Modal
          className="modal-export"
          isOpen={this.state.modalNotify}
          toggle={this.toggleNotify}
        >
          <ModalHeader toggle={this.toggleNotify}>
            <Warning style={{ color: "#FFC107" }} />
            แจ้งเตือน
          </ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <Label for="textNotify">ข้อความแจ้งเตือน</Label>
                <Input value={this.state.txtnoti} type="textarea" name="txtnoti" id="txtnoti" onChange={this.handleChangeInput} />
              </FormGroup>
              <FormGroup>
                <Label for="notifydate">วันที่แจ้งเตือน</Label>
                <Input
                onChange={this.handleChangeInput}
                value={this.state.daten}
                  type="date"
                  name="daten"
                  id="notifydate"
                  placeholder="กรุณาเลือกวันที่"
                />
              </FormGroup>
              <FormGroup>
                <Label for="notifydate">เวลา</Label>
                <Input
                onChange={this.handleChangeInput}
                value={this.state.timen}
                  type="time"
                  name="timen"
                  id="timen"
                  placeholder="กรุณาเลือกวันที่"
                />
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="success" onClick={this.addNoti}>
              ยืนยัน
            </Button>{" "}
            {/* <Button color="secondary" onClick={this.toggleChangeStatus}>
              ยกเลิก
            </Button> */}
          </ModalFooter>
        </Modal>

        {/*Modal Receive Email */}
        <Modal
          className="modal-export"
          isOpen={this.state.modalReceiveEmail}
          toggle={this.toggleReceiveEmail}
        >
          <ModalHeader toggle={this.toggleReceiveEmail}>
            <Warning style={{ color: "#FFC107" }} />
            ยืนยัน
          </ModalHeader>
          <ModalBody>
            <h6>ยืนยันการส่งอีเมล์</h6>
          </ModalBody>
          <ModalFooter>
            <Button
              color="success"
              onClick={() => {
                this.toggleReceiveEmail();
                this.sendEmail();
              }}
            >
              ยืนยัน
            </Button>{" "}
            <Button color="secondary" onClick={this.toggleReceiveEmail}>
              ยกเลิก
            </Button>
          </ModalFooter>
        </Modal>

        {/* Modal Search */}
        <Modal
          className="modal-search"
          isOpen={this.state.modalSearch}
          toggle={this.toggleSearch}
        >
          <ModalHeader toggle={this.toggleSearch}>แสดงสถานะทั้งหมด</ModalHeader>
          <ModalBody>
            <div className="text-right">
              <Button onClick={this.toggleExport} color="primary">
                <Icon style={{ paddingTop: "4px" }}>tableChart</Icon>
                <b>Export Excel</b>
              </Button>
            </div>
            <br />
            <MaterialTable
              title="สถานะทั้งหมด"
              onRowClick={(e, d) => this.showContactModal(d)}
              options={{
                columnsButton: true
              }}
              columns={[
                {
                  title: "สถานะ",
                  field: "status",
                  defaultSort: "desc",
                  cellStyle: { width: "1px" }
                },
                { title: "ชื่อบริษัท", field: "company_thname" },
                { title: "ชื่อลูกค้า", field: "contact_name" },
                { title: "เบอร์ติดต่อ", field: "contact_no" },
                { title: "อีเมล์", field: "contact_email" },
                {
                  title: "ชื่อ Call Center",
                  field: "call_center_name"
                },
                {
                  title: "ชื่อฝ่ายขาย",
                  field: "sale_name"
                },
                {
                  title: "เลขประจำตัวผู้เสียภาษี",
                  field: "tax_id",
                  defaultSort: "desc"
                }
                // {
                //   title: "ชื่อฝ่ายขาย",
                //   render: rowdata => {
                //     return (
                //       <div>
                //         {/* {rowdata.acfirstname === null
                //           ? "-ไม่มีฝ่ายขาย-"
                //           : rowdata.acfirstname +
                //             " " +
                //             rowdata.aclastname} */}
                //              {rowdata.sale_name}
                //       </div>
                //     );
                //   }
                // }
              ]}
              data={this.state.dataAll}
            />
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              style={{ margin: "15px" }}
              onClick={this.toggleSearch}
            >
              ปิด
            </Button>
          </ModalFooter>
        </Modal>

        {/* Modal Addnote */}
        <Modal
          className="modal-upload"
          isOpen={this.state.modalAddnote}
          toggleUpload={this.toggleAddnote}
        >
          <ModalHeader toggle={this.toggleAddnote}>เพิ่มโน๊ต</ModalHeader>
          <ModalBody>
            <CustomInput
              labelText="เพิ่มโน๊ตที่นี่..."
              id="addnote"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                name: "note",
                multiline: true,
                rows: 3,
                value: this.state.note,
                onChange: this.handleChangeInput
              }}
            />
            <FormGroup>
              <Label for="exampleFile">
                เลือกไฟล์ ('txt', 'pdf', 'png', 'jpg', 'jpeg',
                'gif','doc','docx','pptx','ppt','xlsx','xls' เท่านั้น)
              </Label>
              <Input
                type="file"
                name="file"
                id="noteFile"
                style={{ border: "2px solid #f5f5f5" }}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="success" onClick={this.AddNote}>
              เพิ่มโน๊ต
            </Button>
            <Button color="secondary" onClick={this.toggleAddnote}>
              ยกเลิก
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

TableList.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(dashboardStyle)(TableList);



// WEBPACK FOOTER //
// ./src/views/TableList/TableList.jsx